import React, { useContext, useRef, useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Text } from "@fluentui/react/lib/Text";
import {
    Modal,
    Panel,
    Pivot,
    Stack,
    Callout,
    Spinner,
    Checkbox,
    PanelType,
    TextField,
    PivotItem,
    IconButton,
    SpinnerSize,
    TooltipHost,
    TooltipDelay,
    DocumentCard,
    ThemeProvider,
    DefaultButton,
    PrimaryButton,
    ContextualMenu,
    DirectionalHint,
    DocumentCardType,
    DocumentCardTitle,
    IContextualMenuItem,
    DocumentCardPreview
} from "@fluentui/react";
import RModal from "react-modal";
import debounce from "lodash/debounce";
import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
import readNDJSONStream from "ndjson-readablestream";
import { toast, ToastContainer, Bounce } from "react-toastify";
import { AuthenticationResult } from "@azure/msal-browser";

import kognifyLogo from "../../assets/kognifyLogo.png";
import lines_placeholder from "../../assets/thumb_placeholder.png";
import feedbackDirectIcon from "../../assets/feedback_icon.png";

import "react-toastify/dist/ReactToastify.css";
import styles from "./Chat.module.css";
import { LuMailQuestion } from "react-icons/lu";
import {
    qLi,
    qUSp,
    qAddGrp,
    chatApi,
    qAddMmbr,
    qCodeChk,
    qHistAdd,
    qGenChart,
    qGetTiers,
    qGetGroups,
    qAddMember,
    qHistDelete,
    qGetChatLog,
    qGetAllUsers,
    qHistGetList,
    qHistEditName,
    qGetLastModV2,
    qHistGetByKey,
    qReqSpaceFiles,
    qHistGetLatest,
    qHistGetRecent,
    qUploadCCAConvo,
    ChatAppResponse,
    qGetCompanyUsers,
    qGetCompFlatList,
    qReqSpaceFilesPost,
    qGetGroupsMemberships,
    qGetSuggestedQuestions,
    qAddExtraConf
} from "../../api";

import { qGetUP, qGetCampaignTargetFids } from "../../api/qpi";

import { useMsal } from "./../../MsalContext";
import { loginRequest } from "../../authConfig";
import { GlobalContext } from "../../GlobalContext";
import { saveItem, loadItem } from "../../storage";

import customTheme from "./../../theme/customTheme";

import { FiUser } from "react-icons/fi";
import { BsCardList } from "react-icons/bs";
import { List28Regular } from "@fluentui/react-icons";

import { IoMdAnalytics } from "react-icons/io";
import { RiSettings4Line } from "react-icons/ri";
import { HiOutlineViewList } from "react-icons/hi";
import { IoShareSocialOutline, IoMicOutline, IoMicOffOutline  } from "react-icons/io5";
import { TbGridDots, TbUserSquareRounded } from "react-icons/tb";
import { MdArrowBackIos, MdSettingsPhone, MdCampaign } from "react-icons/md";
import { LuBrainCircuit, LuPanelRightClose } from "react-icons/lu";


import { QuestionInput } from "../../components/QuestionInput";
import { QuestionInputXplrr } from "../../components/QuestionInputXplrr";
import { Answer, AnswerError, AnswerLoading, AnswerHi, AnswerDocs } from "../../components/Answer";

import { getConvoKeyTimestampHires } from "./../../components/SpeechRecognizer/process_v2";
import { createEmptyConnectionState, prepConnState } from "../../components/SpeechRecognizer/util_v2";

import { DocFieldSettings } from "../../components/DocFieldSelection/DocFieldSettings";
import { CallAssistantSettings } from "../../components/DocFieldSelection/CallAssistantSettings";
import { DetailsListDocumentsExample } from "../../components/detailedList";

import XplrrPDF from "../../components/XplrrPDF/XplrrPDF";
import XplrrPDFDiff from "../../components/XplrrPDF/XplrrPDFDiff";
import XplrrPDFSideByChat from "../../components/XplrrPDFSideByChat/XplrrPDFSideByChat";

import InviteUserCallout from "../../components/InviteUserCallout/InviteUserCallout";
import FeedbackDirectCallout from "../../components/FeedbackDirectCallout/FeedbackDirectCallout";
import FieldSelectionForInvoices from "../../components/FieldSelection/FieldSelectionForInvoices";
import UserList from "../../components/UserList/UserList";
import CompList from "../../components/CompList/CompList";
import SpacePanel from "../../components/SpacePanel/SpacePanel";
import TwiLMWebCCA from "../../components/TwiLMWebCCA/TwiLMWebCCA";
import AccountInfo from "../../components/AccountInfo/AccountInfo";
import SpeechOutput from "./../../components/SpeechOutput/SpeechOutput";
import CompEditForm from "../../components/CompEditForm/CompEditForm";
import NoSpacesCard from "../../components/NoSpacesCard/NoSpacesCard";
import DicebearThumb from "../../components/DicebearThumb";
import AddSpaceModal from "../../components/AddSpaceModal/AddSpaceModal";
import SpaceEditForm from "../../components/SpaceEditForm/SpaceEditForm";
import GroupCardsList from "../../components/GroupCardsList/GroupCardsList";
import SpaceUserListV2 from "../../components/SpaceUserListV2/SpaceUserListV2";
import AnalyticsConvoList from "../../components/AnalyticsConvoList/AnalyticsConvoList";
import CampaignManager from "../../components/CampaignManager/CampaignManager";
import { SettingsButton } from "../../components/SettingsButton";
import { ListItemButton } from "../../components/ListItemButton";
import { UserChatMessage } from "../../components/UserChatMessage";
import { ClearChatButton } from "../../components/ClearChatButton";
import { TogglePanelButton } from "../../components/TogglePanelButton";
import { libPivotHiddenStyles, textFieldModalSupportStyles, tooltipHostStyles} from "./../../styles_glob";
import {
    gfile,
    gConf,
    ggroup,
    gtiers,
    gcompflat,
    gfeedback,
    gnewgroup,
    camp_c_onf,
    gconvoitem,
    gactivecomp,
    gChatlogItem,
    livecachemap,
    qconvoupload,
    empty_line_config,
    gloggedinuser,
    gqasimplified,
    gdiffresponse,
    cachemantimes,
    gselectedgroup,
    ispdfmodalopen,
    gfileuserselect,
    livecacheactions,
    livecachemapitem,
    qsentenceforaudio,
    emptyaudiosentence,
    ispdfdiffmodalopen,
    gsuggestedquestions,
    gconvorunonmessagepart,
    grecentconvosaccrossspaces,
    empty_extraction_field_list,
    gXplrrCitationChangeCallback,
    ownersProps,
    empty_contenttype_config,
    empty_extraction_field_list_string,
    empty_contenttype_config_string,
    empty_line_config_string
} from "../../interfaces";
import {
    msgLmtHit,
    locCodeType,
    getEmptyRecog,
    locationCodes,
    assistantCodes,
    helpMailTooltip,
    supportFlowTarget,
    FLOOR_DATE_STRING,
    dfltSettingsLocalStr,
    localStorageAuthUriKey,
    localStorageAuthTokKey,
    defaultGreetingsMessage,
    localStorageConfigObjKey,
    defaultPromptTemplateAsInPythonBackend
} from "../../lsts";
import {
    get_ovrrds,
    getLastMod,
    getTokenMail,
    handleIsDark,
    getSpaceModId,
    getFileCacheId,
    getWindowTitle,
    emptyIsPDFOpen,
    safeJsonUnwrap,
    getCacheLastMod,
    setConvoV2State,
    getChunkRandomId,
    extractPageValue,
    hasSentenceEnder,
    cleanFileIDString,
    getTokenAccountID,
    joinShortSentences,
    emptyIsPDFDiffOpen,
    splitIntoSentences,
    extractFileIDValue,
    endsWithPunctuation,
    handleNonStreamChat,
    preserveLocalConfig,
    create_chatapprequest,
    onXplrrPDFModelClosed,
    startConvoEvntDispatch,
    transformFileSelection,
    removeRefTagsClosedOnly,
    checkWeAreInGeneralPlace,
    groupListToSelectedGroup,
    parseInvoiceDataFromFiles,
    onXplrrPDFModelDiffClosed,
    determineCategoryAndGroups,
    createSuggestedQuestionsHTML,
    preserve_convo_collected_data,
    prep_question_and_answers_list
} from "./ChatUtil";
import {
    getLoc,
    garble,
    strToInt,
    cacheCompV2,
    stillInGroup,
    shuffleArray,
    newConvoStamp,
    genNewConvoKey,
    makeValidHtmlId,
    removeExtension,
    stopWigglePixel,
    ccaReplacements,
    isElementVisible,
    parseJsonField,
    fetchThumbnailCached,
    removeEnclosingQuotes,
    upsertGFiles,
    fileHotLinkInURL,
    notEmptyStr,
    genRandomStr,
    safeJsonParse,
    replaceExtrConfig,
    replaceAndParseJsonV2,
    replaceAndParseJson

} from "./../../util_glob";
import {
    libPivotStyles,
    panelRowStyles,
    historyPanelStyles,
    chatAdmPivotStyles,
    textChatFileFilterStyles,
    prdAssistantExternalFileListStyle
} from "./../../styles_glob";

import paragraphStyles from "../../components/ParagraphOverlayFX/ParagraphOverlay.module.css";




const Chat = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { msalInstance, getToken } = useMsal();
    const [token, setToken] = useState<AuthenticationResult | null>();
    const {
        user,
        allUsrs,
        setUser,
        fileList,
        groupList,
        setAllUsrs,
        activeComp,
        setCompUsrs,
        setFileList,
        compMbrshps,
        loggedInUser,
        setGroupList,
        setActiveComp,
        selectedGroup,
        setCompMbrshps,
        setLoggedInUser,
        setSelectedGroup,
        permissionLevels,
        setSourceHighlighting
    } = useContext(GlobalContext);

    const redeemURLRef = useRef<string | null>(null);
    const msgCanvasRef = useRef<HTMLCanvasElement | null>(null);
    const xplrrMsgStrm = useRef<HTMLDivElement | null>(null);
    const convChunksStr = useRef<string>('');
    const answersLength = useRef<number>(0);
    const clickedCitation = useRef<any>(null);
    const lastQuestionRef = useRef<string>('');
    const isLoadingRef = useRef<boolean>(false);
    const convActvSentnce = useRef<qsentenceforaudio>(emptyaudiosentence);
    const addUserButtonRef = useRef<HTMLDivElement>(null);
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);
    const redeemURLSecondPathRef = useRef<string | null>(null);
    const convoRunOnInputMessage = useRef<gconvorunonmessagepart[]>([]);
    const feedbackDirectButtonRef = useRef<HTMLDivElement>(null);
    const [isLib, setIsLib] = useState<string>('');
    const [error, setError] = useState<unknown>();
    const [lTiers, setLTiers] = useState<gtiers[]>();
    const [convos, setConvos] = useState<gconvoitem[]>([]);     // historic convos
    const [config, setConfig] = useState<gConf>(JSON.parse(localStorage.getItem(localStorageConfigObjKey) || dfltSettingsLocalStr));
    const [answers, setAnswers] = useState<[user: string, response: ChatAppResponse][]>([]);
    const [initLoad, setInitLoad] = useState<boolean>(false);
    const [isIframe, setIsIframe] = useState<number>();
    const [thumbMap, setThumbMap] = useState<Map<string, string>>(new Map());
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [fileCount, setFileCount] = useState<number>(0);
    const [fidSelect, setFidSelect] = useState<string[]>([]);
    const [loadingMsg, setLoadingMsg] = useState<string>('');
    const [isSpeaking, setIsSpeaking] = useState<boolean>(false);   // true when speaking. false when not speaking
    const [isStreaming, setIsStreaming] = useState<boolean>(false);
    const [lastMessage, setLastMessage] = useState<string[]>([]);
    const [noMembership, setNoMembership] = useState<boolean>(false);
    const [isCcaChat, setIsCcaChat] = useState<boolean>(false);     // run text chat when cca group
    const [newSpacePyro, setNewSpacePyro] = useState<string>('');
    const [compFlatList, setCompFlatList] = useState<gcompflat[]>([]);
    const [accMenuItems, setAccMenuItems] = useState<IContextualMenuItem[]>([]);
    const [spaceChatLog, setSpaceChatLog] = useState<gChatlogItem[]>([]);
    const [isBlurredFull, setIsBlurredFull] = useState<boolean>(false);
    const [isConvoModeOn, setIsConvoModeOn] = useState<boolean>(false);
    const [isMobileWidth, setIsMobileWidth] = useState<boolean>(window.innerWidth < 768);
    const [thumbnailUrls, setThumbnailUrls] = useState<string[]>(fileList.map(() => lines_placeholder));
    const [activeConvoKey, setActiveConvoKey] = useState<string>('');           // active convo key [bigint yyyyMMddHHmmss]
    const [noGroupsShared, setNoGroupsShared] = useState<boolean>(false);
    const [isSpeechPaused, setIsSpeechPaused] = useState<boolean | null>(null);
    const [isPDFModalOpen, setIsPDFModalOpen] = useState<ispdfmodalopen>(emptyIsPDFOpen);
    const [versionInvData, setVersionInvData] = useState<any>(undefined);       // 🕰️ transient previous-version invoicedata (view-only, never cached/saved)
    const [includeCategory, setIncludeCategory] = useState<string>('');
    const [streamedAnswers, setStreamedAnswers] = useState<[user: string, response: ChatAppResponse][]>([]);
    const [isLeftPanelOpen, setIsLeftPanelOpen] = useState<boolean>(false);     // history panel state
    const [shouldPlayAudio, setShouldPlayAudio] = useState<string>('');
    const [supportQuestion, setSupportQuestion] = useState<string>('');
    const [xplrrChatVisible, setXplrrChatVisible] = useState<boolean>(false);
    const [isSpacePanelOpen, setIsSpacePanelOpen] = useState<boolean>(false);
    const [isSpaceModalOpen, setIsSpaceModalOpen] = useState<boolean>(false);   // new space modal state
    const [isConfigPanelOpen, setIsConfigPanelOpen] = useState<boolean>(false);
    const [isNewSpaceInfoBip, setIsNewSpaceInfoBip] = useState<boolean>(false); // new space info bip state
    const [suggestedQuestions, setSuggestedQuestions] = useState<gsuggestedquestions[]>();
    const [isCancellingMidway, setIsCancellingMidway] = useState<boolean>(false);
    const [userMailForSupport, setUserMailForSupport] = useState<string>('');
    const [isSupportModalOpen, setIsSupportModalOpen] = useState<boolean>(false);
    const [isPDFDiffModalOpen, setIsPDFDiffModalOpen] = useState<ispdfdiffmodalopen>(emptyIsPDFDiffOpen);
    const [isSpacePanelLoading, setIsSpacePanelLoading] = useState<boolean>(false);
    const [transformedFileList, setTransformedFileList] = useState<gfileuserselect[]>([]);
    const [greetingMessageHtml, setGreetingMessageHtml] = useState<string>('');
    const [initialLoadComleted, setInitialLoadComleted] = useState<boolean>(false);
    const [isUserListModalOpen, setIsUserListModalOpen] = useState<boolean>(false);
    const [isCompListModalOpen, setIsCompListModalOpen] = useState<boolean>(false);
    const [convo_discard_stamp, set_convo_discard_stamp] = useState<number>(0);
    const [isSpaceEditModalOpen, setIsSpaceEditModalOpen] = useState(false);    // edit space modal state
    const [isAccountMenuVisible, setIsAccountMenuVisible] = useState<boolean>(false);
    const [isFeedbackDirectOpen, setIsFeedbackDirectOpen] = useState(false);
    const [includeCategoryGroups, setIncludeCategoryGroups] = useState<string>('');
    const [isShareCalloutVisible, setIsShareCalloutVisible] = useState<boolean>(false);
    const [loadingChatModeSwitch, setLoadingChatModeSwitch] = useState<boolean>(false); // edit space modal state
    const [recentConvosAccrosSpaces, setRecentConvosAccrosSpaces] = useState<grecentconvosaccrossspaces[]>();
    const [isSpaceAnalyticsModalOpen, setIsSpaceAnalyticsModalOpen] = useState(false);  // edit space modal state
    const [question_and_answers_list, set_question_and_answers_list] = useState<gqasimplified[]>([]);
    const [expected_next_user_response_type, set_expected_next_user_response_type] = useState<string>("");
    const [randoCcaCampRefresh, setRandoCcaCampRefresh] = useState<string>("");

    // chart regeneration state (managed at parent level for performance)
    const [chartRegenCallout, setChartRegenCallout] = useState<{
        isOpen: boolean;
        answerIndex: number;
        anchorEl: HTMLDivElement | null;
        answer: ChatAppResponse | null;
    }>({ isOpen: false, answerIndex: -1, anchorEl: null, answer: null });
    const [chartInstruction, setChartInstruction] = useState('');
    const [isChartLoading, setIsChartLoading] = useState(false);
    const [chartLoadingIndex, setChartLoadingIndex] = useState<number>(-1);

    lines_placeholder;

    // entry point
    useEffect(() => {
        if (!msalInstance) return;

        hndlIfrm();
        setInitLoad(true);
        if (initialLoadComleted === false) {
            applyLocalConfig();
            qGetUserInfo().then(userObj => {
                if (userObj === null) {
                    uMenuEmpty();
                    setNoMembership(true);
                    if (userObj === null) {
                        uMenuEmpty();
                        setNoMembership(true);
                        fetch(import.meta.env.VITE_EXT_SERV_ANIP)
                            .then(response => response.json())
                            .then(data => {
                                if (data && data?.ip && data?.ip != "") {
                                    qLi('land', `user_is_null ${data.ip}`, getHeader(), user?.userMail || 'no_usermail');
                                } else {
                                    qLi('land', `user_is_null nip`, getHeader(), user?.userMail || 'no_usermail');
                                }
                                return;
                            });
                    }
                    return;
                }
                getCompFlatList().then((cFlatList: gcompflat[]) => {
                    setInitialLoadComleted(true);
                    qLi('land', `init_load`, getHeader(), userObj.userMail || user?.userMail || 'no_usermail');
                    handlePathNavigation(cFlatList, userObj);
                });
            });

            prepConnState(loggedInUser, selectedGroup, []);
            setConvoV2State('global_is_tracking_silence', false);
            setConvoV2State('globalConvPerfRecog',    getConvoKeyTimestampHires());
            setConvoV2State('convoPerfOnRecogFin',    getConvoKeyTimestampHires());
            setConvoV2State('global_run_on_sentence', getEmptyRecog());

            // legacy convo state
            window.global_is_tracking_silence = false;
            window.globalConvPerfRecog        = getConvoKeyTimestampHires();
            window.convoPerfOnRecogFin        = getConvoKeyTimestampHires();
            window.global_run_on_sentence     = getEmptyRecog();
        }
        window.greetingMessageAddNewSpace = (param: string) => {
            if (isIframe && isIframe > 0) {
                toast.error("This feature is not available in the embedded version of the app.");
            } else {
                qUSp("dataEx", "1", getHeader());
            }
        };
        window.greetingMessageViewDocs = (param: string) => {
            if (isIframe && isIframe > 0) {
                toast.error("This feature is not available in the embedded version of the app.");
            } else {
                const currentPath = window.location.hash.split("/");
                currentPath[currentPath.length - 1] = "library";
                window.location.hash = currentPath.join("/");
                return false;
            }
        };
        window.greetingMessageStartCall = () => {document.getElementById("twiLMWebCCACallBtn")?.click()};
        getTiers();

    }, [msalInstance]);

    // track state
    useEffect(() => {
        import.meta.env.DEV === true && console.log("‹usr›", loggedInUser);
    }, [loggedInUser]);

    useEffect(() => {
        import.meta.env.DEV === true && console.log("‹fileCount›", fileCount);
    }, [fileCount]);

    // on comp change
    useEffect(() => {
        if (activeComp.companyid !== '') {
            uMenu(user, compFlatList, activeComp);
            getGroups().then((groupList: any) => {
                if (user && user.userId && user.userId !== '') {
                    let subpaths;
                    if (redeemURLSecondPathRef.current) {
                        let rU = redeemURLSecondPathRef.current;
                        subpaths = rU.split("/").filter(Boolean);
                        redeemURLSecondPathRef.current = null;
                    } else {
                        subpaths = getLoc().split("/").filter(Boolean);
                    }
                    const groupPath = decodeURIComponent(subpaths[1]);
                    if (selectedGroup.selectionId !== groupPath || groupPath == undefined) {
                        if (groupList && groupList.length > 0) {
                            setNoGroupsShared(false);
                            let gr = groupList.filter((group: any) => group.groupid === groupPath)[0];
                            if (gr) {
                                setSelectedGroup(groupListToSelectedGroup(gr));
                            } else {
                                if (groupPath) navigate(`/${activeComp.companyid}`);
                            }
                        } else {
                            setNoGroupsShared(true);
                        }
                    }
                }
            });
            getCompanyUsers();
        }
    }, [activeComp]);


    const handleCcaChat = (selectedGroup: gselectedgroup, loggedInUser: gloggedinuser) => {
        if(selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.line_config?.twi_lmapp && selectedGroup.line_config?.twi_lmapp != ""){
            setIsCcaChat(false)
        } else{
            qGetUP(loggedInUser, selectedGroup.def_campaign_id).then(resp => {
                window.global_u_cmp_obj = resp as camp_c_onf[];
                setIsCcaChat(prev => !prev)
                setRandoCcaCampRefresh(genRandomStr(8));
            })

            import.meta.env.DEV === true && console.log("‹🎙️‾is_cca_chat›", true);
        }
    }

    // on space change
    useEffect(() => {
        if (selectedGroup.selectionId !== "") {
            setConvos([]);
            window.global_u_cmp_obj = null; // helper for cca chat

            // campaign eligibility: load AI-matched file ids for this user as a campaign target
            if (selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.campaigns_enabled == 1) {
                import.meta.env.DEV === true && console.log('‹fid_camp›', selectedGroup);
                qGetCampaignTargetFids(loggedInUser, selectedGroup.selectionId)
                    .then(fids => { window.globalCampDataArr = fids; })
                    .catch(() => { window.globalCampDataArr = []; });
            } else {
                window.globalCampDataArr = [];
            }

            handleCcaChat(selectedGroup, loggedInUser);

            wipeStreamInProgress();
            setLoadingChatModeSwitch(true);
            newConverson();

            import.meta.env.DEV === true && console.log("‹🔅‾space›", selectedGroup);

            qGetSpaceFiles(true, true, selectedGroup).then((fls: Array<gfile>) => {
                setInitLoad(false);

                document.title = getWindowTitle(selectedGroup.selectionText);

                closeSBSWhenScrenTooSmall(true);
                dealWithFilesForPDFViewers(fls);
            });
            // example result ['AA', '000000AA_aaa0a000-0000-0000-0000-0aa00000aa00_AA0A0', 'chat']
            const subpaths = getLoc().split("/").filter(Boolean);

            if (subpaths?.[3]) {
                // if convo id supplied
                histGetByKey(user.userId, subpaths?.[3]).then(() => setLoadingChatModeSwitch(false));
            } else {
                qHistGetLatest(user.userId, selectedGroup.selectionId, activeComp.companyid, 1, getHeader()).then((lConv: any) => {
                    if (lConv && lConv.length > 0 && selectedGroup?.dontloadlastconvo != 1) {
                        setActiveConvoKey(lConv[0].key); // set active convo key to latest key (datetime str)
                        const histObj = JSON.parse(lConv[0].content);
                        setAnswersFunction(histObj, true);
                        setStreamedAnswers(histObj);
                    } else {
                        setActiveConvoKey(genNewConvoKey(selectedGroup.assistanttype)); // set active convo key to newly created (datetime str)
                        setAnswersFunction([], true);
                        setStreamedAnswers([]);
                    }
                    setLoadingChatModeSwitch(false);
                });
            }
            if (selectedGroup?.permissionlevel >= 2) getGroupsMemberships();
        }

        setIsStreaming(false);
        isLoadingRef.current = false
        setIsLoading(false);
        // content scoping related
        window.global_fidsel = [];
        setFidSelect([]);
        window.global_selected_id = selectedGroup.selectionId;

    }, [selectedGroup]);

    // isconvomodeon
    useEffect(() => {
        // wipe convo mode artefacts when turned off
        if (isConvoModeOn == false) {
            if (notEmptyStr(convChunksStr.current)) convChunksStr.current = "";
            if (convActvSentnce.current.answerid != emptyaudiosentence.answerid) convActvSentnce.current = emptyaudiosentence;
        }
    }, [isConvoModeOn]);

    // config change
    useEffect(() => {
        if (initLoad == false) {
            if (!activeConvoKey) return;
            setLoadingChatModeSwitch(true);
            const oldConvo = activeConvoKey;
            setConversation(oldConvo);
        }
        setShouldPlayAudio(Math.random().toString(36).substring(2, 6));
    }, [config.showDocLibInChatTab]);

    // fetch thumbnails on filelist, group or comp change
    useEffect(() => {
        if (selectedGroup && selectedGroup.assistanttype == assistantCodes.prd) fetchThumbnails(fileList, activeComp);
    }, [fileList, selectedGroup, activeComp]);

    // scope selection
    useEffect(() => {
        const manageThumbMap = async () => {
            for (let i = 0; i < fidSelect.length; i++) {
                if (thumbMap.has(fidSelect[i]) && thumbMap.get(fidSelect[i]) !== lines_placeholder) {
                    continue;
                } else {
                    let filNeeded = fileList.find(f => f.fileid === fidSelect[i]);
                    if (!filNeeded) {
                        setThumbMap(prevMap => new Map(prevMap).set(fidSelect[i], lines_placeholder));
                    } else {
                        const url = await fetchThumbnailCached(filNeeded.fileid?.toString(), filNeeded.modified, filNeeded.ownerid, activeComp.companyid);
                        setThumbMap(prevMap => new Map(prevMap).set(fidSelect[i], url));
                    }
                }
            }
        };
        manageThumbMap();
        window.global_fidsel = fidSelect;
    }, [fidSelect]);

    // is location library - islib
    useEffect(() => {
        chatMessageStreamEnd.current?.scrollIntoView({ behavior: "auto" });
        setShouldPlayAudio(Math.random().toString(36).substring(2, 6));
    }, [isLib]);

    // is speaking - set globals
    useEffect(() => {
        if (isSpeaking == false) {
            window.global_convo_last_speech_finish = newConvoStamp();
            setConvoV2State("global_convo_last_speech_finish", getConvoKeyTimestampHires());
        } else {
            window.global_convo_last_speech_start = newConvoStamp();
            setConvoV2State("global_convo_last_speech_start", getConvoKeyTimestampHires());
        }
    }, [isSpeaking]);

    // streamed  answers - scroll to end
    useEffect(() => {
        if (window.globalStreamOneSecondFlag == false || typeof window.globalStreamOneSecondFlag === "undefined") {
            window.globalStreamOneSecondFlag = true;
            if (xplrrMsgStrm.current) {
                if (xplrrMsgStrm.current.scrollHeight - (xplrrMsgStrm.current.scrollTop + xplrrMsgStrm.current.clientHeight) < 250) {
                    if (chatMessageStreamEnd.current) smoothScrollIntoView(chatMessageStreamEnd.current, { behavior: "smooth" });
                }
            }
            const timeoutId = setTimeout(() => {
                window.globalStreamOneSecondFlag = false;
                clearTimeout(timeoutId);
            }, 500);
        }
    }, [streamedAnswers]);

    // isstreaming - set global
    useEffect(() => {
        if (isStreaming == false) window.globalAnswerStreamingFirstCitationFlag = false;
    }, [isStreaming]);

    // answers, showdoclibinchattab - scroll chat to end
    useEffect(() => {
        scrollChatToEnd();
    }, [answers, config.showDocLibInChatTab]);

    // location
    useEffect(() => {
        if (initialLoadComleted == true) handlePathNavigation(compFlatList, user);
    }, [location]);

    // suggested questions
    useEffect(() => {
        setGreetingMessageHtml(createSuggestedQuestionsHTML(selectedGroup, suggestedQuestions));
    }, [suggestedQuestions]);

    // blanket effect
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.altKey && event.key.toLowerCase() === "p") {
                event.preventDefault();
                setIsConfigPanelOpen(!isConfigPanelOpen);
            }
        };
        const handleResize = debounce(() => {
            closeSBSWhenScrenTooSmall();
            setIsMobileWidth(window.innerWidth < 768);
        }, 500);
        window.addEventListener("resize", handleResize);
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("keydown", handleKeyDown);
            handleResize.cancel();
        };
    }, []);

    // save convo to local storage (convo history) (indexed hash array of arrays)
    useEffect(() => {
        if (answers && answers.length > 0) {
            if (answersLength.current != answers.length && (selectedGroup.assistanttype != assistantCodes.cca || isCcaChat == true)) {
                histAdd(parseInt(activeConvoKey), user.userId, selectedGroup.selectionId, activeComp.companyid, answers[0][0]);
                answersLength.current = answers.length;
            }
            !activeConvoKey && newConverson();
        }
        let question_answer_simplified_list: gqasimplified[] = prep_question_and_answers_list(answers);

        set_question_and_answers_list(question_answer_simplified_list);
        window.global_simple_convo_list = question_answer_simplified_list;
        setConvoV2State('global_simple_convo_list', question_answer_simplified_list);

        window.greetingMessageBeginConversation = (param: string) => {
            if (param != '') {
                if (selectedGroup.assistanttype == assistantCodes.cca) {
                    startConvoEvntDispatch(param);
                } else {
                    makeApiRequest(param);
                }
            } else {
                let dcs = fileList.map((f: gfile) => f.name);
                let shfl = shuffleArray([...dcs]).slice(0, 3);
                makeApiRequest(shfl.join(', '));
            }
        };
        if (isConvoModeOn == true) {
            setTimeout(() => {
                convChunksStr.current = '';
                convActvSentnce.current = emptyaudiosentence;
            }, 2000);
        }
        setLastMessage([answers?.length ? answers[answers.length - 1][1].choices[0].message.content : ""]);
    }, [answers]);

    // activeconvokey
    useEffect(() => {
        clickedCitation.current = "";
        window.globalConvoKey = activeConvoKey;
        setConvoV2State("globalConvoKey", activeConvoKey);

        prepConnState(loggedInUser, selectedGroup, []);
        if (answers && answers.length > 0) {
            window.global_expected_next_user_response_type = answers[answers.length - 1][1]?.expected_next_user_response_type || "";
            window.global_active_scenario_id = answers[answers.length - 1][1]?.active_scenario_id || "";
            setConvoV2State("global_expected_next_user_response_type", answers[answers.length - 1][1]?.expected_next_user_response_type || "");
            setConvoV2State("global_active_scenario_id", answers[answers.length - 1][1]?.active_scenario_id || "");
        } else {
            window.global_active_scenario_id = "";
        }
    }, [activeConvoKey]);

    // config - save config to local storage
    useEffect(() => {
        preserveLocalConfig(config, localStorageConfigObjKey);
        setSourceHighlighting(config.sourceHighlighting);
    }, [config]);

    // filelist
    useEffect(() => {
        window.globalFL = fileList;
        if (selectedGroup.assistanttype == assistantCodes.cca) {
            window.globalFL.map((fil: gfile) => {
                fil.invoicedata = typeof fil?.invoicedata === 'string' ? safeJsonUnwrap(removeEnclosingQuotes(fil?.invoicedata || '"[]"')) : fil?.invoicedata;
            });
        }
        if (fileList?.length > 0) openFileHotlink();

        setTransformedFileList(transformFileSelection(fileList, window.global_fidsel || []));
    }, [fileList]);

    // isloading
    useEffect(() => {
        chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" });
    }, [isLoading]);

    //  xplrrchatvisible
    useEffect(() => {
        chatMessageStreamEnd.current?.scrollIntoView({ behavior: "auto" });
    }, [xplrrChatVisible]);

    // header
    const getHeader = useCallback((token?: any) => {
        if (token) {
            return {
                ...(loggedInUser?.token ? { Authorization: `Bearer ${token.accessToken}` } : {}),
                "X-MS-CLIENT-PRINCIPAL-NAME": getTokenMail(token),
                "X-MS-CLIENT-PRINCIPAL-ID": getTokenAccountID(token),
                "Content-Type": "application/json"
            };
        } else {
            return {
                ...(loggedInUser?.token ? { Authorization: `Bearer ${loggedInUser.token}` } : {}),
                "X-MS-CLIENT-PRINCIPAL-NAME": loggedInUser?.mail ? loggedInUser.mail : "",
                "X-MS-CLIENT-PRINCIPAL-ID": loggedInUser?.userId ? loggedInUser.userId : "",
                "Content-Type": "application/json"
            };
        }
    }, [loggedInUser]);


    // get thumbnails
    const fetchThumbnails = async (fileList:gfile[], activeComp: gactivecomp ) => {
        for (let i = 0; i < fileList.length; i++) {
            const url = await fetchThumbnailCached(fileList[i].fileid?.toString(), fileList[i].modified, fileList[i].ownerid, activeComp.companyid);
            setThumbnailUrls(prevUrls => {
                const updatedUrls = [...prevUrls];
                updatedUrls[i] = url;
                return updatedUrls;
            });
        }
    };

    const isSpaceChanging = (selectionId: string) => {
        let check = (window.global_selected_id != selectionId);
        import.meta.env.DEV && console.log("‹check›", check);
        return check
    }

    // nav chat
    const navChatTab = () => {
        navigate(`${activeComp.companyid}/${selectedGroup.selectionId}/chat`);
    };

    // nav library
    const navLibTab = () => {
        navigate(`/${activeComp.companyid}/${selectedGroup.selectionId}/library`);
    };

    // nav chat or library
    const navChatLib = (loc: string, groupid: string) => {
        if (loc == locationCodes.chat) {
            navigate(`/${activeComp.companyid}/${groupid}/chat`);
        } else {
            if (isSpaceChanging(groupid)) setFileList([]);
            navigate(`/${activeComp.companyid}/${groupid}/library`);
        }
    };

    // external hotlink files
    useEffect(() => {
        let subpaths = getLoc().split("/").filter(Boolean);
        if (fileList?.length > 0 && subpaths.length > 3) openFileHotlink();
    }, [location, fileList]);

    // nav group
    const navGrpTab = () => {
        setIsSpacePanelOpen(false);
        navigate(`${activeComp.companyid}`);
    };

    // handle path - handle nav - path navigation handler
    const handlePathNavigation = async (cFlatList: gcompflat[], userObj: any) => {
        /** handles majority of user routing
         *  subpats 0 › root
         *  subpats 1 › comp
         *  subpats 2 › comp / group ¦ adm
         *  subpats 3 › comp / group / chat ¦ library ¦ explorer
         *  subpats 4 › comp / group / chat / convo key
         *  subpats 4 › comp / group / library / fileid
        */

        // test command: window.location.hash.replace("#", "").split('/').filter(Boolean)
        let subpaths = getLoc().split("/").filter(Boolean);
        if (redeemURLRef.current) {
            let rU = redeemURLRef.current;
            subpaths = rU.split("/").filter(Boolean);
            window.history.replaceState({}, "", `${window.location.origin}/#${rU}`);
            redeemURLRef.current = null;
        }
        subpaths.length > 0 && pathGetValidComp(cFlatList, subpaths);

        //  subpath 0: root
        if (subpaths.length == 0) {
            import.meta.env.DEV === true && console.log("‹0: root›");
            const homeComps = cFlatList.filter((comp: any) => comp.companyid == userObj?.companyid) || [];

            if (homeComps.length > 0) {
                navigate(`/${homeComps[0].companyid}`);
            } else if (cFlatList.length > 0) {
                navigate(`/${cFlatList[0].companyid}`);
            } else {
                setNoMembership(true);
                uMenuEmpty();
                return;
            }

        } else if (subpaths.length === 1) { //  subpath 1: root › comp
            import.meta.env.DEV === true && console.log("‹1: root › comp");
            if (isPDFModalOpen.isOpen == true) onXplrrPDFDismiss()

            setIsLib(locationCodes.grp);
            closeSBS();
            // change company if not the same current
            if (activeComp.companyid !== subpaths[0]) {
                if (cFlatList.length > 0) {
                    const comp = cFlatList.filter((comp: any) => comp.companyid === subpaths[0])?.[0] || null;
                    if (comp) {
                        setActiveComp(comp);
                    } else {
                        navigate("/");
                    }
                }
            }
        } else if (subpaths.length >= 2) { //  subpath 2: root › comp / group ¦ adm
            let groupPath = decodeURIComponent(subpaths[1]);

            // intead of group could be adm
            let isUserMenu = groupPath == locationCodes.acc || groupPath == locationCodes.adm;

            // comp change
            if (activeComp.companyid !== subpaths[0]) {
                closeSBS();
                if (userObj && userObj.userId && userObj.userId !== "") {
                    applyLocalConfig();
                    if (cFlatList.length > 0) {
                        const comp = cFlatList.filter((comp: any) => comp.companyid === subpaths[0])?.[0] || null;
                        if (comp) {
                            setActiveComp(comp);
                            if (groupPath == locationCodes.acc) {
                                await getTiers();
                                setIsLib(locationCodes.acc);
                            } else if (groupPath == locationCodes.adm) {
                                await getAllUsers();
                                setIsLib(locationCodes.adm);
                            } else {
                                setIsLib(locationCodes.grp);
                            }
                        }
                        isLoadingRef.current = false
                        setIsLoading(false);
                    } else {
                        isLoadingRef.current = false
                        setIsLoading(false);

                    }
                }

            } else {    // comp - no change
                if (selectedGroup.selectionId !== groupPath) { // group change
                    closeSBS();
                    // if groups
                    if (groupList?.length > 0) {
                        // get chosen group
                        let gr = groupList.filter((group: any) => group.groupid === groupPath)?.[0] || null;
                        if (gr != null) { // set group to found group
                            setSelectedGroup(groupListToSelectedGroup(gr));
                        } else if (groupPath == locationCodes.acc) {
                            await getTiers();
                            setIsLib(locationCodes.acc);
                        } else if (groupPath == locationCodes.adm) {
                            await getAllUsers();
                            setIsLib(locationCodes.adm);
                        } else { // reload. no access to group, but has access to other groups
                            setSelectedGroup(groupListToSelectedGroup());
                            window.location.href = "/";
                            window.location.reload();
                            return;
                        }
                    } else { // no groups available
                        if (groupPath == locationCodes.acc) {
                            await getTiers();
                            setIsLib(locationCodes.acc);
                        } else if (groupPath == locationCodes.adm) {
                            await getAllUsers();
                            setIsLib(locationCodes.adm);
                        } else {
                            setSelectedGroup(groupListToSelectedGroup());
                            window.location.href = "/";
                            window.location.reload();
                            return;
                        }
                    }
                } else { // group no change
                    if (subpaths?.[3]) {
                        histGetByKey(user.userId, subpaths?.[3]).then(() => setLoadingChatModeSwitch(false));
                    } else {
                        isLoadingRef.current = false
                        setIsLoading(false);
                    }
                }
            }
            if (subpaths?.[2]) { // comp / group / chat ¦ library ¦ explorer
                if (subpaths[2] == "chat") { // check if convo key supplied (ub chat)
                    if (subpaths?.[3]) setActiveConvoKey(subpaths[3]);
                    setIsLib(locationCodes.chat);
                } else if (subpaths[2] === "library") {
                    setIsLib(locationCodes.lib);
                } else if (subpaths[2] === "explorer") {
                    setIsLib(locationCodes.xplr);
                }
            } else if (isUserMenu == false) {
                setIsLib(locationCodes.grp);
            }
        }
    };

    // open history panel
    const toggleLeftPanel = () => {
        histGetList(user.userId, selectedGroup.selectionId, activeComp.companyid, 5);
        setIsLeftPanelOpen(!isLeftPanelOpen);
    };

    // open spaces panel
    const toggleSpacePanel = () => {
        if (isSpacePanelOpen == false) {
            if (recentConvosAccrosSpaces && recentConvosAccrosSpaces.length > 0) {
                setIsSpacePanelOpen(!isSpacePanelOpen);
                histGetRecent(user.userId, activeComp.companyid);
            } else {
                setIsSpacePanelLoading(true);
                histGetRecent(user.userId, activeComp.companyid).then((convos: any) => {
                    setIsSpacePanelOpen(!isSpacePanelOpen);
                    setIsSpacePanelLoading(false);
                });
            }
        } else {
            setIsSpacePanelOpen(!isSpacePanelOpen);
        }
    };

    // library space analytics
    const openSpacesAnalyticsPanel = () => {
        getChatLog();
        setIsSpaceAnalyticsModalOpen(true);
    };

    // trigger refresh. legacy ⇒ manage include category (legacy for file scoped chatting)
    const updateCatsState = (newVal: string) => {
        // after file is uploaded. toast notification
        if (newVal !== "") {
            if (newVal.includes("¦Unsuported URL ⇛ Only Youtube Supported for Now")) {
                // unsuported url
            } else {
                let subpaths = window.location.hash.split("/").filter(Boolean);
                if (subpaths.length > 2) {
                    if (decodeURIComponent(subpaths[2]) == selectedGroup.selectionId) {
                        qGetSpaceFiles(false, true).then((fls: Array<gfile>) => {
                            setInitLoad(false);
                            closeSBSWhenScrenTooSmall(true);
                            if (fls && fls.length > 0) {
                                const dFl = fls[0];
                                const fileStrng = `${dFl.name}_page=${1}_fid=${dFl.fileid}`;
                                setIsPDFModalOpen({
                                    defaultFile: fileStrng,
                                    startPage: '1',
                                    isOpen: false,
                                    searchString: '',
                                    contentlist: dFl?.contentlist || [],
                                    pagemap: dFl?.pagemap || {},
                                    fileId: dFl.fileid,
                                    refPageNum: '1',
                                    isCitation: false,
                                    rndo: Math.random().toString(36).substring(2, 6),
                                    activeGroupId: selectedGroup.selectionId,
                                    fileList: fls,
                                    fl: dFl
                                });
                            } else {
                                setIsPDFModalOpen({
                                    defaultFile: '',
                                    startPage: '1',
                                    isOpen: false,
                                    searchString: '',
                                    contentlist: [],
                                    pagemap: {},
                                    fileId: '',
                                    refPageNum: '1',
                                    isCitation: false,
                                    rndo: Math.random().toString(36).substring(2, 6),
                                    activeGroupId: selectedGroup.selectionId,
                                    fileList: fls,
                                    fl: undefined
                                });
                            }
                        });
                    }
                }
            }
        }
    };

    // refresh filelist
    const listRefreshRequest = (fileids?: string, isfromchat?: boolean, gid?:string, data_tables_change?: boolean) => {
        // data_tables_change - invoice data tables were updated
        let subpaths = window.location.hash.split("/").filter(Boolean);

        if (gid && window.global_selected_id && gid !== window.global_selected_id) return;

        if (subpaths.length > 2 || data_tables_change == true) {

            if (decodeURIComponent(subpaths[2]) == selectedGroup.selectionId) {

                qGetSpaceFiles(false, true).then((fls: Array<gfile>) => {
                    if((fileids && (fileids?.split(";") || []).length > 0 && isfromchat && isfromchat == true)) {
                        let fileidsArr = fileids?.split(";") || [];
                        let newFidSel = Array.from(
                            new Set([
                            ...fidSelect,
                            ...fileidsArr.map(id => id)
                            ])
                        );
                        setFidSelect(prev =>
                            Array.from(
                                new Set([
                                ...prev,
                                ...fileidsArr.map(id => id)
                                ])
                            )
                        );
                        setTransformedFileList(prev =>
                            transformFileSelection(fls, newFidSel)
                        );
                    }
                });
            }
        }
    };

    // get comp from path
    const pathGetValidComp = (cFlatList: gcompflat[], subpaths: string[]) => {
        if (cFlatList.length > 0) {
            const comp = cFlatList.filter((comp: any) => comp.companyid === subpaths[0])[0];
            if (comp) {
                import.meta.env.DEV === true && console.log('‹path_cmp›', comp?.companyname);
            } else {
                navigate("/");
            }
        }
    };

    // iframe handler
    const hndlIfrm = () => {
        if (window.location.href?.indexOf("ifrm=true") > 0 == true) {
            // legacy - ifrm was boolean
            setIsIframe(1);
        } else if (window.location.href?.indexOf("ifrm=1") > 0 == true) {
            setIsIframe(1);
        } else if (window.location.href?.indexOf("ifrm=2") > 0 == true) {
            setIsIframe(2);
            switchXplrrModuleVisibility();
        } else {
            setIsIframe(0);
        }
    };

    // dyn tok
    const getTokenDyn = async () => {
        const utok = localStorage.getItem(localStorageAuthTokKey);
        if (utok) {
            const utokcache: AuthenticationResult = JSON.parse(utok);
            setToken(utokcache);
            return utokcache;
        }
        if (!msalInstance) return null;
        if (token) return token;

        let tkn = await getToken(loginRequest.scopes);
        setToken(tkn);
        return tkn;
    };

    // parse the dateModifiedValue url param (format: "YYYYMMDD-YYYYMMDD", e.g. 20260310-20260529).
    // detailedList writes this filter INSIDE the hash (createHashRouter), so we read it from there.
    const getKgnfDateRange = (): { start?: Date; end?: Date } => {
        const hash = window.location.hash || "";
        const body = hash.startsWith("#") ? hash.slice(1) : hash;
        const qIdx = body.indexOf("?");
        const params = new URLSearchParams(qIdx === -1 ? "" : body.slice(qIdx + 1));
        const raw = params.get("dateModifiedValue");
        if (!raw) return {};

        const parsePart = (part: string): Date | null => {
            if (!/^\d{8}$/.test(part)) return null;
            const year = Number(part.slice(0, 4));
            const month = Number(part.slice(4, 6));
            const day = Number(part.slice(6, 8));
            const date = new Date(year, month - 1, day);
            // validate (guards against e.g. month 13 rolling over)
            if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
                return null;
            }
            return date;
        };

        const parts = raw.split("-");
        if (parts.length !== 2) return {};

        const start = parsePart(parts[0]);
        const end = parsePart(parts[1]);
        if (!start || !end) return {};

        return { start, end };
    };

    // redeem (give permissions via link)
    const redeemCode = async (userMail: string) => {
        let params = new URLSearchParams(window.location.search);
        let rdmCd = params.get("redeemCode");
        let convCode = params.get("convCode") || undefined;
        let mE = params.get("mE") ||'0';
        let anon = params.get("A") || '0';
        let sub = params.get("sub") || '';
        let navlib = params.get("lib") || '0';

        if (rdmCd !== null) {
            params.delete("redeemCode");
            params.delete("spt");
            params.delete("A");
            params.delete("convCode");
            params.delete("mE");
            params.delete("sub");
            params.delete("lib");

            const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : '');
            if (userMail !== '') {
                let userCheck = await qCodeChk(rdmCd, userMail, mE, convCode);
                if (userCheck.cmp) {
                    if (!groupList.some((g: ggroup) => g.groupid == rdmCd)) {
                        let navU = convCode ? `/${userCheck.cmp}/${rdmCd}/chat/${convCode}` : navlib == '0' ? `/${userCheck.cmp}/${rdmCd}/chat` : `/${userCheck.cmp}/${rdmCd}/library`;
                        redeemURLRef.current = navU;
                        redeemURLSecondPathRef.current = navU;
                    }
                } else {
                    window.history.replaceState({}, '', newUrl);
                }
            } else {
                window.history.replaceState({}, '', newUrl);
            }
        }
        return rdmCd;
    };

    // hotlink handler (open file from link)
    const openFileHotlink = () => {
        if (!fileList || fileList.length == 0) return;
        let hotLinkInfo: [boolean, string]  = fileHotLinkInURL()
        if (hotLinkInfo && hotLinkInfo?.[0] == true) {
            const item = fileList.find(f => f.fileid == hotLinkInfo?.[1]);

            if (!item) return;
            setTimeout(() => {onShowCitation(`${item.name}#page=1_fid=${hotLinkInfo[1]}`, null, 0, undefined)}, 200);
        }
    };

    // deal with files for PDF viewers
    const dealWithFilesForPDFViewers = (fls: Array<gfile>) => {
        if (fls && fls.length > 0) {
            const dFl = fls[0];
            const fileStrng = `${dFl.name}_page=${1}_fid=${dFl.fileid}`;
            setIsPDFModalOpen({
                defaultFile: fileStrng,
                startPage: '1',
                isOpen: false,
                searchString: '',
                contentlist: dFl?.contentlist || [],
                pagemap: dFl?.pagemap || {},
                fileId: dFl.fileid,
                refPageNum: '1',
                isCitation: false,
                rndo: Math.random().toString(36).substring(2, 6),
                activeGroupId: selectedGroup.selectionId,
                fileList: fls,
                fl: dFl
            });
        } else {
            closeSBSWhenNoFiles();
            setIsPDFModalOpen({
                defaultFile: '',
                startPage: '1',
                isOpen: false,
                searchString: '',
                contentlist: [],
                pagemap: {},
                fileId: '',
                refPageNum: '1',
                isCitation: false,
                rndo: Math.random().toString(36).substring(2, 6),
                activeGroupId: selectedGroup.selectionId,
                fileList: fls,
                fl: undefined
            });
        }
    };

    // close sbs when screen too small
    const closeSBSWhenScrenTooSmall = (dontSendToast?: boolean) => {
        if (window.innerWidth < 768) {
            if (config.showDocLibInChatTab == true) {
                if (dontSendToast != true)
                    toast.warning("Side-by-Side View for Chat and Documents is currently not supported on screens with less than 768px of width");

                setConfig(prevConfig => ({
                    ...prevConfig,
                    showDocLibInChatTab: false
                }));

                return;
            }
        }
    };

    // close sbs when no files
    const closeSBSWhenNoFiles = () => {
        if (config.showDocLibInChatTab == true) {
            setConfig(prevConfig => ({
                ...prevConfig,
                showDocLibInChatTab: false
            }));
        }
        return;
    };

    // close sbs
    const closeSBS = () => {
        if (config.showDocLibInChatTab == true) {
            setConfig(prevConfig => ({
                ...prevConfig,
                showDocLibInChatTab: false
            }));
        }
    };

    // empty user menu
    const uMenuEmpty = () => {
        const newAccountMenuItems = [
            {
                key: 'Logout',
                text: 'Logout',
                onClick: () => {
                    if (msalInstance) {
                        msalInstance
                            .logoutPopup({
                                postLogoutRedirectUri: '/',     // redirects the top level app after logout
                                account: msalInstance.getActiveAccount(),
                                onRedirectNavigate: url => {
                                    return true;
                                }
                            })
                            .then(() => {
                                localStorage.removeItem(localStorageAuthUriKey);
                                localStorage.removeItem(localStorageAuthTokKey);
                                if (isIframe && isIframe > 0) {
                                    window.location.reload();
                                } else {
                                    window.location.href = window.location.href;
                                }
                            });
                    }
                },
                iconProps: { iconName: 'SignOut' }
            }
        ];
        setAccMenuItems(newAccountMenuItems);
    };

    // user menu
    const uMenu = (userObj: any, cFlatList: gcompflat[], homeComp: any) => {
        const newAccountMenuItems = [
            {
                key: 'User',
                disabled: true,
                text: userObj.userMail,
                iconProps: { iconName: 'Contact' }
            },
            {
                key: 'DarkMode',
                disabled: false,
                text: 'User Settings',

                iconProps: { iconName: 'Settings' },
                onClick: () => {
                    setIsConfigPanelOpen(true);
                }
            },
            {
                key: 'Logout',
                text: userObj.userMail.indexOf('quest_') > -1 ? 'Quest Logout' : 'Logout',
                onClick: () => {
                    if (msalInstance) {
                        msalInstance
                            .logoutPopup({
                                postLogoutRedirectUri: "/", // redirects the top level app after logout
                                account: msalInstance.getActiveAccount(),
                                onRedirectNavigate: url => {
                                    return true;
                                }
                            })
                            .then(() => {
                                localStorage.removeItem(localStorageAuthUriKey);
                                localStorage.removeItem(localStorageAuthTokKey);
                                if (isIframe && isIframe > 0) {
                                    window.location.reload();
                                } else {
                                    window.location.href = window.location.href;
                                }
                            });
                    }
                },
                iconProps: { iconName: 'SignOut' }
            }
        ];

        try {
            if (cFlatList && cFlatList.length > 0 && cFlatList.some(a => a.permissionlevel >= 3 && a.companyid === homeComp.companyid) && isIframe == 0) {
                newAccountMenuItems.splice(1, 0, {
                    key: 'ManageUsers',
                    text: 'Administrative',
                    onClick: () => {openUserList()},
                    iconProps: { iconName: 'Admin' }
                });
            }
            if (userObj.userMail.indexOf('quest_') == -1 && isIframe == 0 && activeComp.licensingkind == 0) {
                newAccountMenuItems.splice(1, 0, {
                    key: 'ManageAccount',
                    text: 'Manage Account',
                    onClick: () => {
                        navigate(`${activeComp.companyid}/acc`);
                    },
                    iconProps: { iconName: 'AccountManagement' }
                });
            }
            if (cFlatList && cFlatList.length > 1 && isIframe == 0) {
                newAccountMenuItems.splice(1, 0, {
                    key: 'ManageCompanies',
                    text: homeComp.companyname,
                    onClick: () => {
                        setIsCompListModalOpen(true);
                    },
                    iconProps: { iconName: 'Group' }
                });
            }
        } catch (err) {
            import.meta.env.DEV === true && console.log('‹u_menu_errr›', err);
        }
        setAccMenuItems(newAccountMenuItems);
    };

    // open user list
    const openUserList = () => {
        getAllUsers().then((users: any) => navigate(`${activeComp.companyid}/adm`));
    };

    // apply local config
    const applyLocalConfig = () => {
        const configObj = localStorage.getItem(localStorageConfigObjKey);
        if (configObj) {
            let configParsed = JSON.parse(configObj);
            configParsed.showDocLibInChatTab = false;
            handleIsDark(configParsed.isDark);
            setConfig(configParsed);
            closeSBSWhenScrenTooSmall();
        } else {
            let configDefault = JSON.stringify(config);
            localStorage.setItem(localStorageConfigObjKey, configDefault);
            closeSBSWhenScrenTooSmall();
        }
    };

    // set anwsers to mem
    const setAnswersFunction = (histObj: any, setAnswersLength?: boolean) => {
        import.meta.env.DEV && console.log("‹setAnswrs›");
        let anLen = (histObj ?? []).length;
        if (setAnswersLength == true) answersLength.current = anLen;

        // get file filtering for latest chat interaction
        if (histObj && histObj.length > 0) {
            let lastInteractionFidSel = histObj[Math.max(0, anLen - 1)][1]?.["fidselect"] || [];
        }
        import.meta.env.DEV === true && console.log("‹answrs_fnc›", histObj);
        setAnswers(histObj);
    };

    // set anwsers to mem
    const setAnswersFunctionV2 = (question: any, parsedResponse: any, setAnswersLength?: boolean) => {
        import.meta.env.DEV && console.log("‹setAnswrs_v2›");

        setAnswers((prevAnswers) => {

            if (setAnswersLength == true) {
                let anLen = ([...prevAnswers, [question, parsedResponse]]).length;
                import.meta.env.DEV && console.log("‹setAnswerLen›", anLen);
                answersLength.current = anLen;
            }
            return [...prevAnswers, [question, parsedResponse]];
        });
    };

    const wipeStreamInProgress = () => {
        import.meta.env.DEV && console.log("‹wipe›");
        setIsStreaming(false);
        isLoadingRef.current = false
        setIsLoading(false);
        setLoadingMsg('');
        setError(undefined);
    }

    // get chat log by key
    const histGetByKey = async (userid: string, key: string, initial_key?: string) => {
        try {
            let keyConvo = await qHistGetByKey(userid, key, getHeader(), initial_key);
            const histObj = JSON.parse(keyConvo[0].content);
            setActiveConvoKey(keyConvo[0].key); // set the active conversation key to the latest key (Datetime string)
            setAnswersFunction(histObj, true);
            setStreamedAnswers(histObj);
            setLoadingChatModeSwitch(false);
        } catch {
            setLoadingChatModeSwitch(false);
        }
    };

    // get recent conv
    const histGetRecent = async (userid: string, company: string) => {
        try {
            let recentConvosUserWide = await qHistGetRecent(userid, company, getHeader());
            setRecentConvosAccrosSpaces(recentConvosUserWide);
        } catch (err) {
            import.meta.env.DEV && console.log("errr_recent_convos", err);
        }
    };

    // get suggested questions
    const getSuggestedQuestions = async (fLst: gfile[]) => {
        try {
            if (fLst.length == 0) return setSuggestedQuestions([]);
            let suggestedQuestions = await qGetSuggestedQuestions(fLst, getHeader());
            setSuggestedQuestions(suggestedQuestions);
        } catch {
            // do nothing
        }
    };

    // get tiers
    const getTiers = async () => {
        let tiers = await qGetTiers(getHeader());
        setLTiers(tiers);
    };

    // get chat list
    const histGetList = async (userid: string, groupid: string, companyid: string, topn: number) => {
        let convos = await qHistGetList(userid, groupid, companyid, topn, getHeader());
        setConvos(convos);
    };

    // add history
    const histAdd = async (key: number, userid: string, groupid: string, companyid: string, name: string, aa?: any) => {
        qHistAdd(key, userid, groupid, companyid, name, getHeader(), aa || answers);
    };

    // gen new convo key
    const newConverson = (convoKey?: string) => {
        if (convoKey) {
            setActiveConvoKey(convoKey);
        } else {
            setActiveConvoKey(genNewConvoKey(selectedGroup.assistanttype));
        }
        setAnswersFunction([], true);
        setStreamedAnswers([]);
        setError(undefined);
        window.global_expected_next_user_response_type = "greeting";
        window.global_convo_collected = {};

        window.global_convo_last_speech_finish = newConvoStamp();
        window.global_convo_last_response_finish = newConvoStamp();

        window.global_is_tracking_silence = false;
        window.global_run_on_sentence = { segments: [], recognized: [] };
        window.global_convo_extr_conf = new Map<string, string[]>();
    };

    // set convo
    const setConversation = (dateString: string) => {
        setLoadingChatModeSwitch(true);
        initialLoadComleted == true && newConverson();
        histGetByKey(user.userId, dateString).then(() => setLoadingChatModeSwitch(false));
        setActiveConvoKey(dateString);
        setIsLeftPanelOpen(false);
    };

    // get chat log
    const getChatLog = async () => {
        let sChatLog: gChatlogItem[] = await qGetChatLog(selectedGroup.selectionId, getHeader());
        setSpaceChatLog(sChatLog);
        return sChatLog;
    };

    // complist ⇒ get list of companies
    const getCompFlatList = async () => {
        const token = await getTokenDyn();
        if (!token) return [];
        let compList = await qGetCompFlatList(getHeader(token));
        setCompFlatList(compList);
        return compList;
    };

    // compmbrshps ⇒ space memberships to show in space edit (qgetgroupsmemberships, qgetcompanyusers) [per comp]
    const getGroupsMemberships = async () => {
        let mbrshpsResp = await qGetGroupsMemberships(activeComp.companyid, getHeader());
        mbrshpsResp ? setCompMbrshps(mbrshpsResp) : setCompMbrshps([]);
        return mbrshpsResp;
    };

    // compusrs ⇒ user picker suggestions  [per comp]
    const getCompanyUsers = async () => {
        let compUsers = await qGetCompanyUsers(activeComp.companyid, getHeader());
        setCompUsrs(compUsers);
        return compUsers;
    };

    // allusrs ⇒ company users list (owner panel)[gets all for user - filters down t comp levl in list]
    const getAllUsers = async () => {
        const token = await getTokenDyn();
        let allUsers = await qGetAllUsers(getHeader(token));
        setAllUsrs(allUsers);
        return allUsers;
    };

    // jsonb columns arrive as (possibly double-encoded) strings ⇒ parse safely w/ per-field fallbacks
    const groupParsingV2 = (grpsresp: any[]) => {
        if (!Array.isArray(grpsresp)) return [];

        for (const g of grpsresp) {
            // null ⇒ defaults applied later in groupListToSelectedGroup
            g.spo_config          = parseJsonField(g.spo_config,   null);
            g.convo_config        = parseJsonField(g.convo_config, null);

            g.contenttype_config  = parseJsonField(g.contenttype_config,  structuredClone(empty_contenttype_config));
            g.line_config         = parseJsonField(g.line_config,         { ...empty_line_config });
            g.extractionfieldlist = parseJsonField(g.extractionfieldlist, structuredClone(empty_extraction_field_list));
            g.gen_opt             = parseJsonField(g.gen_opt,             {});

            const dec             = parseJsonField<any>(g.docextractionconfig, []);
            g.docextractionconfig = Array.isArray(dec) ? dec : [];
        }
        return grpsresp;
    };

    const groupParsing = (grpsresp: any[]) => {
        // parse json configs
        for (let i = 0; i < grpsresp.length; i++) {
            // spo config json parse

            if (grpsresp[i].spo_config && typeof grpsresp[i].spo_config === 'string') grpsresp[i].spo_config = JSON.parse(grpsresp[i].spo_config);

            // convo config json parse
            if (grpsresp[i].convo_config && typeof grpsresp[i].convo_config === 'string') grpsresp[i].convo_config = JSON.parse(grpsresp[i].convo_config);

            // content type config json parse
            if (grpsresp[i].contenttype_config && typeof grpsresp[i].contenttype_config === 'string') {
                grpsresp[i].contenttype_config = JSON.parse(grpsresp[i].contenttype_config || empty_contenttype_config_string);
            } else {
                grpsresp[i].contenttype_config = grpsresp[i].contenttype_config || empty_contenttype_config;
            }

            // line config json parse
            if (grpsresp[i].line_config && typeof grpsresp[i].line_config === 'string') {
                grpsresp[i].line_config = JSON.parse(grpsresp[i].line_config || empty_line_config_string);
            } else {
                grpsresp[i].line_config = grpsresp[i].line_config || empty_line_config;
            }

            // extraction field list json parse
            if (grpsresp[i].extractionfieldlist && typeof grpsresp[i].extractionfieldlist === 'string') {
                grpsresp[i].extractionfieldlist = JSON.parse(grpsresp[i].extractionfieldlist || empty_extraction_field_list_string);
            } else {
                grpsresp[i].extractionfieldlist = grpsresp[i].extractionfieldlist || empty_extraction_field_list;
            }

            // doc extraction config json parse
            if (grpsresp[i].docextractionconfig && typeof grpsresp[i].docextractionconfig === 'string') {
                try {
                    grpsresp[i].docextractionconfig = replaceAndParseJson(grpsresp, i) // replaceAndParseJson(grpsresp, i)
                    import.meta.env.DEV === true && console.log("‹docextrconf_parsed›", grpsresp[i].docextractionconfig);
                } catch {
                    console.log("‹errr‾pars‾docextrconf‾group›");
                }
            } else {
                grpsresp[i].docextractionconfig = grpsresp[i]?.docextractionconfig || {};
            }

            // general group options json parse
            if (grpsresp[i].gen_opt && typeof grpsresp[i].gen_opt === 'string') {
                try {
                    grpsresp[i].gen_opt = JSON.parse(grpsresp[i].gen_opt);
                } catch {
                    grpsresp[i].gen_opt = {};
                    import.meta.env.DEV && console.log('‹gopt›')
                }
            } else {
                grpsresp[i].gen_opt = grpsresp[i].gen_opt || {};
            }
        }
        return grpsresp;
    }

    const getGroups = async (cmp?: string) => {
        let grpsresp = await qGetGroups(cmp ?? activeComp.companyid, getHeader());

        const grpsrespcurr = groupParsing(grpsresp);
        if (grpsrespcurr) setGroupList(grpsrespcurr);
        return grpsrespcurr;

    }

    // grouplist ⇒ spaces list + permissions level [per comp]
    const getGroupsV2 = async (cmp?: string) => {
        let headers       = getHeader()

        let grpsresp = await qGetGroups(cmp ?? activeComp.companyid, headers);
        let grpsrespcurr = groupParsing(grpsresp);

        localStorage.setItem(`sgrid_${headers['X-MS-CLIENT-PRINCIPAL-ID']}_${cmp}`, JSON.stringify(grpsrespcurr));
        window.globalActvCmpId = activeComp?.companyid;

        return grpsrespcurr;
    };

    const getGrpoupsAsync = async (cmp?: string, headers?: any, companyid?: string) => {
        let grpsresp = await qGetGroups(cmp ?? activeComp.companyid, headers);
        let grpsrespcach = groupParsing(grpsresp);

        localStorage.setItem(`sgrid_${headers['X-MS-CLIENT-PRINCIPAL-ID']}_${cmp}`, JSON.stringify(grpsrespcach));
        return null;
    };

    // handle comp change
    const handleCompChange = (activeComp: gcompflat) => {
        navigate(`/${activeComp.companyid}`);
        setIsCompListModalOpen(false);
    };

    // qgetusrinf ⇒ user + default company
    const qGetUserInfo = async () => {
        const token = await getTokenDyn();
        if (!token) return null;

        let redeemResult = await redeemCode(getTokenMail(token));

        setLoggedInUser({
            userId: getTokenAccountID(token),
            mail: getTokenMail(token),
            token: token.accessToken
        });

        const response = await fetch("/qGetUserInfo", {
            headers: {
                ...getHeader(token),
                ...{ kgnfhsh: window.location.hash?.replace(/[^a-zA-Z0-9]/g, " ") }
            }
        });

        if (!response.ok) console.log('errr_usr', response);

        let userRes = await response.json();

        setUser({
            userDisplayName: userRes.userDisplayName,
            userId: userRes.userId,
            userMail: userRes.userMail,
            companyid: userRes.companyid,
            name: (token.idTokenClaims as any).name,
            tier: userRes.tier,
            subscriptionid: userRes.subscriptionid,
            status: userRes.status
        });

        return userRes;
    };

    // handle active sentence
    const handleConvoActiveSentence = (txt: string, direct?: boolean, askResponse?: any) => {
        try {
            if (direct == true) {
                import.meta.env.DEV === true && console.log('‹direct›', txt);
                convActvSentnce.current = {
                    answerid: askResponse ? askResponse?.interaction_guid : '',
                    text: txt,
                    convoid: window.globalConvoKey,
                    chunkid: getChunkRandomId()
                };
            } else {
                convChunksStr.current = `${convChunksStr.current}${txt}`;

                // remove integrated data tags [doc123]
                convChunksStr.current = removeRefTagsClosedOnly(convChunksStr.current);

                // check if the sentence has a sentence ender or tag
                if (!hasSentenceEnder(convChunksStr.current) || convChunksStr.current.indexOf("[doc") > -1) return;

                // join all chunks up to now, split to sentences and joint sub 5 char sentences
                let sentencesArr = joinShortSentences(splitIntoSentences(convChunksStr.current) || []);

                // if no sentences, return
                if (sentencesArr.length == 0) return;

                // if the first sentence does not end with a sentence ender, return
                if (/[.!?:]$/.test(sentencesArr[0].trim()) == false) return;

                import.meta.env.DEV === true && console.log('‹4_shift›', txt);
                convActvSentnce.current = {
                    answerid: askResponse ? askResponse?.interaction_guid : '',
                    text: sentencesArr[0].replace("*", ''),
                    convoid: window.globalConvoKey,
                    chunkid: getChunkRandomId()
                }; // active sentence

                sentencesArr.shift(); // remove first item
                convChunksStr.current = sentencesArr.join('');
            }
        } catch (e) {
            console.error("‹errr_convo_active_sentence›", e);
        }
    };

    // chat main
    const makeApiRequest = async (
        question: string,
        q_seq_id?: number,
        current_intent?: string,
        ignore_discard?: boolean,
        additional_string_data?: string,
        msgovrride?: string
    ) => {
        window.globalIsCancellingMidway = false;
        if ((selectedGroup.premiumby ?? '') == '' && selectedGroup.dailymsgs > (lTiers?.at(0)?.msgsplmt || 0)) {
            toast.warning(msgLmtHit);
            return;
        }

        if (isConvoModeOn == true) {
            // manage audio
            convChunksStr.current = '';
            convActvSentnce.current = emptyaudiosentence;

            // prepend previous messages
            convoRunOnInputMessage.current.push({ message: question, convostamp: window.convoPerfOnRecogFin });
            question = convoRunOnInputMessage.current.map(a => a.message).join(" ");
        }

        if (isStreaming) return;

        lastQuestionRef.current = question;

        error && setError(undefined);
        isLoadingRef.current = true
        setIsLoading(true);

        const dynFiltering = determineCategoryAndGroups(selectedGroup, includeCategory, includeCategoryGroups);

        let fidSelOpti = window.global_fidsel || [];

        if (window.global_fidsel?.length == window.globalFL.length) fidSelOpti = [];

        const ovrrds = get_ovrrds(
            selectedGroup,
            config,
            user,
            activeComp,
            activeConvoKey,
            dynFiltering,
            additional_string_data || '',
            window.global_expected_next_user_response_type, // current_intent
            msgovrride || '',
            fidSelOpti
        );

        import.meta.env.DEV === true && console.log("‹ovrrds›", ovrrds);

        try {
            let inplaceupdate = false;
            if (answers.length > 0 && answers[answers.length - 1][1].discard == true){
                import.meta.env.DEV && console.log('‹in_place_update›')
                inplaceupdate = true;
            }

            const request = create_chatapprequest(question, answers, ovrrds, inplaceupdate);

            let response;
            let grpIdStamp = `${selectedGroup.selectionId}`
            scrollChatToEnd();
            setLoadingMsg('Sending...');

            window.global_convo_last_response_start = getConvoKeyTimestampHires();
            setConvoV2State('global_convo_last_response_start', getConvoKeyTimestampHires());

            response = await chatApi(request, loggedInUser);

            setIsSpeechPaused(null);

            if (!response.body) throw Error('no_response_body');

            if (config.shouldStream) {
                const parsedResponse: ChatAppResponse = await handleAsyncRequest(question, answers, response.body, inplaceupdate, ignore_discard, grpIdStamp);
                if (stillInGroup(grpIdStamp) != true) {
                    wipeStreamInProgress();
                    return;
                }

                parsedResponse.pos = null;
                parsedResponse.use_integrated_search = true;

                // convo mode, handle conversational cadance minutiae by alowing answers to be discarded
                if (inplaceupdate == true) {
                    import.meta.env.DEV && console.log("‹inplaceupdate_discard›")

                    // break cycle of discard, by setting the current replacement to discard false
                    if (parsedResponse.discard != true && parsedResponse) {
                        import.meta.env.DEV && console.log("‹answr_resp_01›", parsedResponse);

                        setStreamedAnswers(prevAnswers =>
                            prevAnswers.length > 0 ? [...answers.slice(0, -1), [question, parsedResponse]] : [[question, parsedResponse]]
                        );
                        setAnswers(prevAnswers =>
                            prevAnswers.length > 0 ? [...answers.slice(0, -1), [question, parsedResponse]] : [[question, parsedResponse]]
                        );
                    }
                } else {
                    if (parsedResponse?.discard != true) {
                        import.meta.env.DEV && console.log("‹answr_resp_02›", parsedResponse);
                        setAnswersFunctionV2(question, parsedResponse, false);
                    } else {
                        import.meta.env.DEV && console.log("‹discard›", parsedResponse);
                    }
                }
            } else {
                import.meta.env.DEV && console.log("‹answr_resp_03›");

                let parsedResult = await handleNonStreamChat(response, question, answers);
                setAnswersFunction([...answers, [parsedResult.question, parsedResult.parsedResponse as ChatAppResponse]], false);
            }

        } catch (e) {
            try{
                setError(e);
                setIsStreaming(false);
                import.meta.env.DEV === true && console.log("‹err_chat_run›", e);
            } catch(e){
                import.meta.env.DEV === true && console.log("‹err_chat_catch›", e);
            }
        } finally {
            try{
                isLoadingRef.current = false
                setIsLoading(false);
            } catch(e){
                import.meta.env.DEV === true && console.log("‹err_chat_finally›", e);
            }
        }
    };

    // chat logic
    const handleAsyncRequest = async (
        question: string,
        answers: [string, ChatAppResponse][],
        responseBody: ReadableStream<any>,
        inplaceupdate: boolean,
        ignore_discard?: boolean,
        groupIdStamp?: string
    ) => {
        let answer: string = '';
        let askResponse: ChatAppResponse = {} as ChatAppResponse;
        window.globalIsCancellingMidway = false;

        const updateState = (newContent: string, direct?: boolean, inplaceupdate?: boolean) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    answer += newContent;
                    answer = answer?.replace(/\\n/g, '\n')
                    isConvoModeOn == true && handleConvoActiveSentence(newContent, direct, askResponse);
                    const latestResponse: ChatAppResponse = {
                        ...askResponse,
                        choices: [{ ...askResponse.choices[0], message: { content: answer, role: askResponse.choices[0].message?.role } }]
                    };

                    if (inplaceupdate == true) {
                        setStreamedAnswers(prevAnswers =>
                            prevAnswers.length > 0 ? [...answers.slice(0, -1), [question, latestResponse]] : [[question, latestResponse]]
                        );
                    } else {
                        setStreamedAnswers([...answers, [question, latestResponse]]);
                    }
                    resolve(null);
                }, 10);
            });
        };

        let convoDiscard = false;
        let groupChanged = false;
        try {
            setIsStreaming(true);

            for await (const event of readNDJSONStream(responseBody)) {
                if ((window.globalIsCancellingMidway as any) == true) break;

                if (stillInGroup(groupIdStamp) != true) {
                    groupChanged = true;
                    break
                }
                if (isConvoModeOn == true) {        // legacy. if answer discard flag is true
                    if (event?.discard == true) {   // legacy: if speech recog asigned ignore_discard is not true, discard the response
                        if (ignore_discard != true) {
                            if (answers.length > 0) {
                                askResponse.discard = true;
                                convoDiscard = true;
                                set_convo_discard_stamp(newConvoStamp());
                                break;
                            }
                        } else {    // discard is true but ignore_discard is also true, so we will not discard the response
                            askResponse.discard = false;
                            convoDiscard = false;
                        }
                    } else if (event?.discard == false) {
                        askResponse.discard = false;
                        convoDiscard = false;
                    }
                }
                if (selectedGroup.assistanttype == assistantCodes.cca) {
                    if (event?.expected_next_user_response_type && event.expected_next_user_response_type != "") {
                        askResponse.expected_next_user_response_type = event.expected_next_user_response_type;
                        set_expected_next_user_response_type(event.expected_next_user_response_type);
                        window.global_expected_next_user_response_type = event.expected_next_user_response_type;

                        setConvoV2State('global_expected_next_user_response_type', event.expected_next_user_response_type);
                    }
                    if (event?.active_scenario_id && event.active_scenario_id != "") {
                        askResponse.active_scenario_id = event.active_scenario_id;
                        window.global_active_scenario_id = event.active_scenario_id;

                        setConvoV2State('global_active_scenario_id', event.active_scenario_id);
                    }
                }
                if (event?.choices?.[0]?.context?.data_points_integrated?.citations) {
                    if (selectedGroup.assistanttype != assistantCodes.cca)  isLoadingRef.current = false

                    event['choices'][0]['message'] = event['choices'][0]['delta'];
                    askResponse = event;
                    if (event['direct']) await updateState(event['choices'][0]['delta']['content'], true, inplaceupdate);

                } else if (event?.choices?.[0]?.delta?.content) {
                    isLoadingRef.current = false
                    try{
                        setIsLoading(false);
                    } catch(e){
                        console.error("‹errr_set_isloading_false›", e);
                    }

                    await updateState(event['choices'][0]['delta']['content'], false, inplaceupdate);

                } else if (event?.choices?.[0]?.context) {
                    try {
                        if (!askResponse?.choices) askResponse = event;
                        askResponse.choices[0].context = { ...askResponse.choices[0].context, ...event['choices'][0]['context'] };
                    } catch (e) {
                        console.error("‹errr_e_0909›", event, "ares", askResponse, e);
                    }

                } else if (event.choices?.[0]?.['message']?.['content']) {
                    await updateState(event['choices'][0]['message']['content'], false, inplaceupdate);

                } else if (event['loading_msg']) {
                    setLoadingMsg(event['loading_msg']);

                } else if (event['error']) {
                    if ((window.globalIsCancellingMidway as any) == true) {
                        import.meta.env.DEV === true && console.log('‹cancel_midway›');
                    } else throw Error(event['error']);
                }
                if (event?.active_scenario_id && event.active_scenario_id != '') {
                    askResponse.active_scenario_id = event.active_scenario_id;
                    window.global_active_scenario_id = event.active_scenario_id;
                }
            }
        } catch (e) {
            console.error("‹errr_hndl_cht›", e);
        }

        if (groupChanged == true) {
            setIsStreaming(false);
            wipeStreamInProgress();
            return {} as ChatAppResponse;
        }

        // convo - add dot so the last sentence can be routed to speech
        if (isConvoModeOn == true && !endsWithPunctuation(answer)) {
            import.meta.env.DEV === true && console.log("‹end_no_punct›");
            handleConvoActiveSentence(".");
        }
        // post_answer convo_discard management
        if (isConvoModeOn == true) {
            if (convoDiscard != true) {
                // last level cache - keep the message until not-discarded response is received.
                convoRunOnInputMessage.current = convoRunOnInputMessage.current.filter((a: any) => a.convostamp > (askResponse.convostamp || 0));

                // convostamp is the convoperfonrecogfin stamp of the recog result that made it to backend and prompted the ai response. recogs after are not yet shared with backend.
                // cadancestamp gets updated only on not-discarded responses. it is used here to shear off last level prompt recog cache and by the recgnizer to manage immediate prompt recog cache.

                window.global_convo_last_response_finish = getConvoKeyTimestampHires();
                setConvoV2State("global_convo_last_response_finish", getConvoKeyTimestampHires());
                setConvoV2State("global_convo_cadance_stamp", getConvoKeyTimestampHires());
            }
        } else {
            setIsStreaming(false);
        }


        if (selectedGroup.assistanttype == assistantCodes.cca) {
            answer = ccaReplacements(answer, selectedGroup.assistanttype);
            convChunksStr.current = ccaReplacements(convChunksStr.current, selectedGroup.assistanttype);
        }
        let fullResponse: ChatAppResponse = {
            ...askResponse,
            choices: [{ ...askResponse.choices[0], message: { content: answer, role: askResponse.choices[0].message?.role } }]
        };
        // main isstreaming flag shut down
        setIsStreaming(false);
        preserve_convo_collected_data(askResponse);
        return fullResponse;
    };

    // scroll chat to end
    const scrollChatToEnd = () => {
        if (xplrrMsgStrm.current) {
            const element = xplrrMsgStrm.current;
            element.scrollTop = selectedGroup?.assistanttype == assistantCodes.prd ? 0 : element.scrollHeight;
        }
    };

    const updateFileCountConditionally = async (flLen: number) => {
        if (flLen != fileCount) setFileCount(flLen);
    }

    // Prefilter the live-cache maps (fileid -> { modified, ... }) by the dateModifiedValue url range.
    // Returns NEW trimmed copies of both maps (originals untouched) so the in-range subsets can be fed straight into cacheCompV2.
    // Only the MAPS are trimmed (for scoping the comparison) - the file arrays are never trimmed, so the on-disk cache always stays full.
    const prefilterMapsByDateRange = (
        fileListMap: livecachemap,
        cacheSrvMap: livecachemap
    ): { fileListMap: livecachemap; cacheSrvMap: livecachemap; isFiltered: boolean } => {
        const { start, end } = getKgnfDateRange();
        if (!start && !end) return { fileListMap, cacheSrvMap, isFiltered: false };

        const startMs = start ? start.getTime() : -Infinity;

        // end is at 00:00 of the day; include the whole end day
        const endMs = end ? end.getTime() + 86_400_000 - 1 : Infinity;

        const inRange = (val: any): boolean => {
            const t = val.modified instanceof Date ? val.modified.getTime() : new Date(val.modified).getTime();
            return !isNaN(t) && t >= startMs && t <= endMs;
        };
        const trim = (map: livecachemap): livecachemap =>
            new Map(Array.from(map).filter(([, val]) => inRange(val)));

        let fileListMapOldCount = fileListMap?.size
        let cacheSrvMapOldCount = cacheSrvMap?.size

        let fileListMapTrim = trim(fileListMap)
        let cacheSrvMapTrim = trim(cacheSrvMap)

        let fileListMapNewCount = fileListMapTrim?.size
        let cacheSrvMapNewCount = cacheSrvMapTrim?.size

        let isFiltered = fileListMapOldCount !== fileListMapNewCount || cacheSrvMapOldCount !== cacheSrvMapNewCount;

        return { fileListMap: fileListMapTrim, cacheSrvMap: cacheSrvMapTrim, isFiltered: isFiltered };
    };

    // get space files + cache
    const qGetSpaceFilesV2 = async (preWipe?: boolean, pullCacheFirst?: boolean, groupPass?: gselectedgroup, updActionArrs?: livecacheactions, doFullRefresh?: boolean): Promise<gfile[]> => {

        if (!groupPass) groupPass = selectedGroup;

        import.meta.env.DEV && console.log('‹🗃️_1›')
        let grupArtfct = `${groupPass.selectionId}`
        let flCache = null;
        if (!updActionArrs) {
            // get cache
            let flCache: gfile[] = await loadItem(getFileCacheId(groupPass.oid)); // get items cache

            // maps - cache & srv
            let cacheSrvMap:livecachemap = await qGetLastModV2(groupPass.selectionId, getHeader());
            let fileListMap:livecachemap = new Map((flCache || []).map((file) => [
                strToInt(file.fileid),
                {
                    fileid: strToInt(file.fileid),
                    modified: new Date(file.modified),
                    docstatus: file.docstatus
                }
            ]));

            // prefilter both maps by the dateModifiedValue url range (keeps on-disk cache intact)
            const prefiltered = prefilterMapsByDateRange(fileListMap, cacheSrvMap);
            fileListMap = prefiltered.fileListMap;
            cacheSrvMap = prefiltered.cacheSrvMap;
            const isFiltered = prefiltered.isFiltered;

            // compare cache & srv (prefiltered by range)
            let updActionArrs: livecacheactions = cacheCompV2(fileListMap, cacheSrvMap);
            import.meta.env.DEV && console.log('‹🗺️_0›', updActionArrs)

            // if no updates whatsoever, return
            if (updActionArrs.forRefresh.size == 0  && updActionArrs.forRemoval.size == 0) {
                import.meta.env.DEV && console.log('‹🗺️_1›')
                updateFileCountConditionally(flCache?.length || -1);
                setFileList(flCache || []);
                setInitLoad(false);
                return flCache || [];
            }

            // if only removals remove them and return
            if (updActionArrs.forRefresh.size == 0 && updActionArrs.forRemoval.size > 0) {
                import.meta.env.DEV && console.log('‹🗺️_2›')
                let newFileCount:number = 0
                let fileListSansRemovals = flCache?.filter(file => !updActionArrs.forRemoval.has(strToInt(file.fileid))) || [];
                newFileCount = fileListSansRemovals.length
                updateFileCountConditionally(newFileCount || -1);
                setFileList(fileListSansRemovals);
                setInitLoad(false);

                saveItem(getFileCacheId(groupPass.oid), fileListSansRemovals);

                return fileListSansRemovals
            }

            //if updates/adds rerun and do all in next run
            if (updActionArrs.forRefresh.size > 0){
                import.meta.env.DEV === true && console.log("‹🧭rerun_with_updates🧭›", updActionArrs, updActionArrs.forRefresh.size);
                return await qGetSpaceFiles(
                    preWipe           = false,
                    pullCacheFirst    = false,
                    groupPass         = groupPass,
                    updActionArrs     = updActionArrs,
                    doFullRefresh     = flCache?.length < 2 || updActionArrs?.forRefresh.size > 1000 ? true : doFullRefresh // pointless
                );
            }
        }

        if (preWipe == true) setFileList([]);

        import.meta.env.DEV === true && console.log('‹🔅updActionArrs🔅›', updActionArrs);

        const dateRange = getKgnfDateRange();
        let flResp:any[]  = await qReqSpaceFilesPost(selectedGroup, activeComp.companyid, setInitLoad, getHeader(), updActionArrs, undefined, dateRange);
        let flArr:gfile[] = parseInvoiceDataFromFiles(flResp);

        if (stillInGroup(grupArtfct) == true) {
            if (flCache == null) flCache = await loadItem(getFileCacheId(groupPass.oid)); // get items cache

            if (updActionArrs && updActionArrs.forRefresh.size > 0) flArr = upsertGFiles(flCache || [], flArr);
            if (updActionArrs && updActionArrs.forRemoval.size > 0) flArr = flArr?.filter(file => !updActionArrs.forRemoval.has(strToInt(file.fileid))) || [];

            updateFileCountConditionally(flArr?.length || -1);
            setFileList(flArr);
            setInitLoad(false);
            getSuggestedQuestions(flArr);
            // flArr is the FULL upserted array (only the comparison maps were trimmed), so persist it always
            saveItem(getFileCacheId(groupPass.oid), flArr);

            return flArr;
        } else {
            import.meta.env.DEV === true && console.log('‹group_switch_02›');
            return []
        }
    };

    // get space files + cache
    const qGetSpaceFiles = async (preWipe?: boolean, pullCacheFirst?: boolean, groupPass?: gselectedgroup, updActionArrs?: livecacheactions, doFullRefresh?: boolean): Promise<gfile[]> => {
        if (!groupPass) groupPass = selectedGroup;
        let grupArtfct = `${groupPass.selectionId}`
        let flCache = null;
        if (!updActionArrs) {
            // get cache
            let flCache: gfile[] = await loadItem(getFileCacheId(groupPass.oid)); // get items cache

            // maps - cache & srv
            let cacheSrvMap:livecachemap = await qGetLastModV2(groupPass.selectionId, getHeader());
            let fileListMap:livecachemap = new Map((flCache || []).map((file) => [
                strToInt(file.fileid),
                {
                    fileid: strToInt(file.fileid),
                    modified: new Date(file.modified),
                    docstatus: file.docstatus
                }
            ]));

            // compare cache & srv
            let updActionArrs: livecacheactions = cacheCompV2(fileListMap, cacheSrvMap);

            // if no updates whatsoever, return
            if (updActionArrs.forRefresh.size == 0  && updActionArrs.forRemoval.size == 0) {
                updateFileCountConditionally(flCache?.length || -1);
                setFileList(flCache || []);
                setInitLoad(false);
                return flCache || [];
            }

            // if only removals remove them and return
            if (updActionArrs.forRefresh.size == 0 && updActionArrs.forRemoval.size > 0) {
                let newFileCount:number  = 0
                let fileListSansRemovals = flCache?.filter(file => !updActionArrs.forRemoval.has(strToInt(file.fileid))) || [];

                newFileCount             = fileListSansRemovals.length
                updateFileCountConditionally(newFileCount || -1);
                setFileList(fileListSansRemovals);
                setInitLoad(false);
                saveItem(getFileCacheId(groupPass.oid), fileListSansRemovals);
                return fileListSansRemovals
            }

            //if updates/adds rerun and do all in next run
            if (updActionArrs.forRefresh.size > 0){
                import.meta.env.DEV === true && console.log("‹🧭rerun_with_updates🧭›", updActionArrs, updActionArrs.forRefresh.size);
                return await qGetSpaceFiles(
                    preWipe           = false,
                    pullCacheFirst    = false,
                    groupPass         = groupPass,
                    updActionArrs     = updActionArrs,
                    doFullRefresh     = flCache?.length < 2 || updActionArrs?.forRefresh.size > 10000 ? true : doFullRefresh // pointless
                );
            }
        }

        if (preWipe == true) setFileList([]);

        import.meta.env.DEV === true && console.log('‹🔅updActionArrs🔅›', updActionArrs);

        let flResp:any[]  = await qReqSpaceFilesPost(selectedGroup, activeComp.companyid, setInitLoad, getHeader(), updActionArrs);


        let flArr:gfile[] = parseInvoiceDataFromFiles(flResp);

        if (stillInGroup(grupArtfct) == true) {
            if (flCache == null) flCache = await loadItem(getFileCacheId(groupPass.oid)); // get items cache

            if (updActionArrs && updActionArrs.forRefresh.size > 0) flArr = upsertGFiles(flCache || [], flArr);
            if (updActionArrs && updActionArrs.forRemoval.size > 0) flArr = flArr?.filter(file => !updActionArrs.forRemoval.has(strToInt(file.fileid))) || [];

            updateFileCountConditionally(flArr?.length || -1);
            setFileList(flArr);
            setInitLoad(false);
            getSuggestedQuestions(flArr);
            saveItem(getFileCacheId(groupPass.oid), flArr);

            return flArr;
        } else {
            import.meta.env.DEV === true && console.log('‹group_switch_02›');
            return []
        }


    };

    // get legacy search string
    const getLegacySearchString = (pageRef: string, index: number) => {
        let searchString;
        try {
            searchString = streamedAnswers?.[index]?.[1]["choices"][0]["context"]["data_points"].find(el => el.startsWith(pageRef));
        } catch {
            let directSearchRes = answers?.[index]?.[1]["choices"][0]["context"]["data_points"] as any;
            searchString = directSearchRes.data_points.find((el: string) => el.startsWith(pageRef));
        }
        searchString = searchString?.replace(pageRef, "").substring(1)?.trim();
        return searchString;
    };

    // show citation handler
    const onShowCitation = (fileP: string, integratedCitation: string | null, index: number, openSBS?: boolean) => {
        if (!fileP) return;

        fileP = cleanFileIDString(fileP);
        let startPage = extractPageValue(fileP);
        let fid = extractFileIDValue(fileP);
        let pageRef = fileP.replace("/content/", "");

        let srchstr = integratedCitation == null ? getLegacySearchString(pageRef, index) : integratedCitation;
        let isOpenBool = config.showDocLibInChatTab == true ? false : true;

        let citFl = window.globalFL.filter((file: gfile) => file.fileid == fid);

        closeSBSWhenScrenTooSmall(true);
        if (citFl.length == 0) {
            toast.warn("File Not Found in Library");
        } else {
            import.meta.env.DEV === true && console.log("‹cit_fip›", fileP.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"));
            setIsPDFModalOpen({
                defaultFile: fileP.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"),
                startPage: startPage,
                isOpen: true,
                searchString: srchstr ? srchstr : '',
                contentlist: citFl[0].contentlist || [],
                pagemap: citFl[0].pagemap || {},
                fileId: fid,
                refPageNum: startPage,
                isCitation: true,
                rndo: "",
                activeGroupId: selectedGroup.selectionId,
                fileList: window.globalFL,
                fl: citFl[0]
            });
        }
    };

    // 🕰️ open the full invoice interface for a previous version (view-only, not cached/saved)
    const onOpenVersionInvoice = (fileId: string, filename: string, invoicedata: any) => {
        const citFl = window.globalFL.filter((file: gfile) => file.fileid == fileId);
        if (citFl.length == 0) {
            toast.warn("File Not Found in Library");
            return;
        }
        setVersionInvData(invoicedata);   // transient override — flows to XplrrPDF, never written to fileList
        setIsPDFModalOpen({
            defaultFile: `${filename}#page=1_fid=${fileId}`.replace("#fid", "_fid").replace("#page", "_page"),
            startPage: "1",
            isOpen: true,
            searchString: "",
            contentlist: citFl[0].contentlist || [],
            pagemap: citFl[0].pagemap || {},
            fileId: fileId,
            refPageNum: "1",
            isCitation: false,
            rndo: Math.random().toString(36).substring(2, 6),
            activeGroupId: selectedGroup.selectionId,
            fileList: window.globalFL,
            fl: citFl[0]
        });
    };

    // show citation xplrr
    const onShowCitationXplrr = (fileP: string, integratedCitation: string | null, index: number, openSBS?: boolean) => {
        setXplrrChatVisible(false);
        if (!fileP || isPDFModalOpen.isOpen === true) return;

        let startPage = extractPageValue(fileP);
        let fleid = extractFileIDValue(fileP);
        let pageRef = fileP.replace("/content/", "");

        let srchstr;
        if (integratedCitation == null) {
            srchstr = getLegacySearchString(pageRef, index);
        } else {
            srchstr = integratedCitation;
        }
        let citFl = window.globalFL.filter((file: gfile) => file.fileid == fleid);
        if (citFl.length == 0) {
            toast.warn("File Not Found in Library");
        } else {
            import.meta.env.DEV === true && console.log("‹xplr_fip›", fileP.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"));
            setIsPDFModalOpen({
                defaultFile: fileP.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"),
                startPage: startPage,
                isOpen: false,
                searchString: srchstr ? srchstr : "",
                contentlist: citFl[0].contentlist || [],
                pagemap: citFl[0].pagemap || {},
                fileId: fleid,
                refPageNum: startPage,
                isCitation: true,
                rndo: Math.random().toString(36).substring(2, 6),
                activeGroupId: selectedGroup.selectionId,
                fileList: window.globalFL,
                fl: citFl[0]
            });
        }
    };

    // manage citation open
    const manageCitationOpen = (filePath: string, integratedCitation: string | null, index: number, el: HTMLElement | null, openSBS?: boolean) => {
        if (clickedCitation) {
            removeCitationActive();
            applyCitationActive(el?.id);
        }
        if (openSBS == true) {
            if (config.showDocLibInChatTab == false) {
                if (window.innerWidth < 768) {
                    onShowCitation(filePath, integratedCitation, index, openSBS);
                } else {
                    setConfig(prevConfig => ({
                        ...prevConfig,
                        showDocLibInChatTab: true
                    }));
                    setTimeout(() => {
                        onShowCitationXplrr(filePath, integratedCitation, index, openSBS);
                        if (clickedCitation?.current) setTimeout(() => { applyCitationActive(clickedCitation.current) }, 1000);
                    }, 50);
                }
            } else {
                onShowCitationXplrr(filePath, integratedCitation, index, openSBS);
            }
        } else if (openSBS == false) {
            if (config.showDocLibInChatTab == true) {
                setConfig(prevConfig => ({
                    ...prevConfig,
                    showDocLibInChatTab: false
                }));
                setTimeout(() => {
                    onShowCitation(filePath, integratedCitation, index, openSBS);
                    if (clickedCitation?.current) {
                        setTimeout(() => {
                            applyCitationActive(clickedCitation.current);
                        }, 1000);
                    }
                }, 50);
            } else {
                onShowCitation(filePath, integratedCitation, index, openSBS);
            }
        } else {
            if (config.showDocLibInChatTab == true) {
                onShowCitationXplrr(filePath, integratedCitation, index, openSBS);
            } else {
                onShowCitation(filePath, integratedCitation, index, openSBS);
            }
        }
    };

    // this is user click not citation change
    const xplrrCitationChangeCallback = (callBackProps: gXplrrCitationChangeCallback) => {
        const citationFullPath = `${callBackProps.filename}#page=1_fid=${callBackProps.fileid}`

        setIsPDFModalOpen(prevConfig => ({
            ...prevConfig,
            isOpen: true,
            defaultFile: citationFullPath,
            startPage: callBackProps.destPageNum,
            searchString: "",
            fileId: callBackProps.fileid,
            isCitation: callBackProps.isCitation,
            rndo: callBackProps.rndo
        }));
    };

    // callback func to handle space update for files
    const handleSelectionChange = (newSelection: { name: string; groupIds: string; groupNames: string }[]) => {
        setIncludeCategory(newSelection.map(item => item.name).join(";"));
        setIncludeCategoryGroups([...new Set(newSelection.map(item => item.groupIds))].join(";")); // get unique group ids for selected files
    };

    // handle space change
    const handleSpaceChange = (selectionId: string, selectionText: string, permissionlevel: number, filecount: number, description: string, aCK?: string, hideRootTabs?: number) => {
        setAnswersFunction([], true);
        setStreamedAnswers([]);
        aCK ? navigate(`/${activeComp.companyid}/${selectionId}/chat/${aCK}`) : hideRootTabs != 1 ? navigate(`/${activeComp.companyid}/${selectionId}/chat`) : navigate(`/${activeComp.companyid}/${selectionId}/library`);
    };

    // compare files
    const onCompareClicked = (file1: string, file2: string, diff: gdiffresponse[]) => {
        if (!file1 || !file2) return;

        file1 = cleanFileIDString(file1);
        file2 = cleanFileIDString(file2);
        let fid1 = extractFileIDValue(file1);
        let fid2 = extractFileIDValue(file2);
        let citFl1 = window.globalFL.filter((file: gfile) => file.fileid == fid1);
        let citFl2 = window.globalFL.filter((file: gfile) => file.fileid == fid2);

        closeSBSWhenScrenTooSmall(true);

        let startPage = extractPageValue(file1);

        if (citFl1?.length == 0 || citFl1?.length == 0) {
            toast.warn("File Not Found in Library");
        } else {
            setIsPDFDiffModalOpen({
                defaultFile1: file1.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"),
                defaultFile2: file2.replace("/content/", "").replace("#fid", "_fid").replace("#page", "_page"),
                isOpen: true,
                searchString: "",
                fileId1: fid1,
                fileId2: fid2,
                refPageNum: startPage,
                isCitation: false,
                rndo: Math.random().toString(36).substring(2, 6),
                activeGroupId: selectedGroup.selectionId,
                fileList: window.globalFL,
                fl1: citFl1[0],
                fl2: citFl2[0],
                diff: diff
            });
        }
    };

    // add space
    const addSpace = async (nGroup: gnewgroup) => {
        if (nGroup.id == '') return null;
        let owners: ownersProps[] = [{ userid: user.userId, username: user.userDisplayName, level: 3, mail: user.userMail, isnew: false }];
        const groupname = nGroup.groupname;
        if (!groupname) {
            setIsSpaceEditModalOpen(false);
            return null;
        }

        qAddGrp(nGroup, activeComp.companyid, defaultPromptTemplateAsInPythonBackend, defaultGreetingsMessage, getHeader())
            .then(Response => {
                let specSet = nGroup?.specializedSettings
                if (specSet?.convo_config && specSet?.convo_config != "" && specSet?.docextractionconfig && specSet?.docextractionconfig != "") {
                    qAddExtraConf(nGroup, getHeader()).catch(error => console.error("errr_add_extr_conf", error));
                }
            })
            .catch(error => console.error("‹errr_add_grp›", error));

        qAddMmbr(owners, nGroup.id, activeComp.companyid, getHeader())
            .then(Response => {
                getGroups().then((grpsresp: any) => {
                    getGroupsMemberships();
                    setNoGroupsShared(false);
                    toast.success("New Space Created");
                    setTimeout(() => {
                        let pageElement = document.querySelector(`#${makeValidHtmlId(nGroup.id)}`);
                        if (pageElement) {
                            smoothScrollIntoView(pageElement, { behavior: "smooth" });
                            setNewSpacePyro(nGroup.id);
                            setTimeout(() => {setNewSpacePyro('')}, 5000);
                        }
                    }, 1);
                });
            })
            .catch(error => console.error("‹errr_add_mbr›", error));

        setIsSpaceModalOpen(false);
        return null;
    };

    // update user management
    const userMngmntUpdate = (timestamp: string) => {
        getCompanyUsers().then(() => {
            getGroupsMemberships().then(() => {
                getCompFlatList().then(() => getAllUsers());
            });
        });
    };

    // handle nav from group list
    const handleGroupListNav = (group: { groupid: string; groupname: string; permissionlevel: number; filecount: number }) => {
        navigate(`/${activeComp.companyid}/${group.groupid}/chat`);
    };

    // handle left space panel click
    const handleLeftSpacePanelClick = (item: any, aCK?: string, hideRootTabs?: number) => {
        setIsSpacePanelOpen(false);
        if (aCK) {
            setLoadingChatModeSwitch(true);
            if (config.showDocLibInChatTab == true) {
                setConfig(prevConfig => ({
                    ...prevConfig,
                    showDocLibInChatTab: false
                }));
            }
        }
        handleSpaceChange(item.groupid, item.groupname, item.permissionlevel, item.filecount, item.description, aCK, item?.hideroottabs ?? hideRootTabs);
    };

    // toggle chat with docs
    const toggleChatWithDocs = () => {
        if (window.innerWidth < 768) {
            toast.warning("Side-by-Side View for Chat and Documents is currently not supported on screens with less than 768px of width");
            return;
        }
        let valNow = true;
        if (config.showDocLibInChatTab == true) valNow = false;
        setConfig(prevConfig => ({
            ...prevConfig,
            showDocLibInChatTab: !!valNow
        }));
    };

    // handle cancel midway
    const handleIsCancellingMidway = () => {
        setIsCancellingMidway(true);
        window.globalIsCancellingMidway = true;
    };

    // handle space save
    const onEditSpaceSave = () => {
        getGroups().then((grpsresp: any) => {
            const gr = grpsresp.filter((group: any) => group.groupid === selectedGroup.selectionId)[0];
            setSelectedGroup(groupListToSelectedGroup(gr));
            toast.success("Space Configuration Saved", { autoClose: 200});
        });
    };

    // handle space delete
    const onGroupDel = () => {
        toast.info("Space Deletion in Progress..", { autoClose: 1000});
        navigate(`/${activeComp.companyid}`);
    };

    // handle pivot click
    const handlePivotItemClick = (item: any, hideRootTabs: number) => {
        if (item.props.itemKey == "back") {
            if (hideRootTabs != 1 && selectedGroup.assistanttype != assistantCodes.ipa && selectedGroup.landonmanage != 1){
                navChatTab();
            } else {
                navGrpTab();
            }
            return;
        } else if (item.props.itemKey == "contact") {
            window.location.href = "mailto:support@example.com?subject=Hello&body=Hi%20there!";
            navLibTab()
            return;
        }
    };

    // handle admin pivot item click
    const handleAdmPivotItemClick = (item: any) => {
        if (item.props.itemKey == "back") {
            navGrpTab();
            return;
        }
    };

    // invite user to group
    const inviteUser = async (usr: string, sendMail?: boolean) => {
        const response = qAddMember(usr, selectedGroup.selectionId, activeComp.companyid, getHeader(), sendMail || false, selectedGroup.selectionText);
        userMngmntUpdate(new Date().toISOString());
        setIsShareCalloutVisible(!isShareCalloutVisible);
        toast.success("User Invited to Assistant", { autoClose: 4000});
    };

    // add a single chat-campaign member to the space permission system (no mail; mail goes out via "Send Mail Invites")
    const inviteCampaignMember = async (usermail: string): Promise<Response> => {
        return await qAddMember(usermail, selectedGroup.selectionId, activeComp.companyid, getHeader(), false, selectedGroup.selectionText);
    };

    // handle new group click
    const onNewGroupClick = () => {
        setIsSpaceModalOpen(true);
        setIsNewSpaceInfoBip(false);
    };

    // handle group item edit
    const histItemHandleEdit = (key: string, newText: string) => {
        const toastId = toast("Changing Conversation Name...", { autoClose: false });
        qHistEditName(key, user.userId, newText, getHeader()).then(() => {
            toast.update(toastId, { render: "Conversation Name Changed", autoClose: 1000 });
        });
    };

    // handle group item delete
    const histItemHandleDelete = (key: string) => {
        const toastId = toast("Deleting Conversation...", { autoClose: false });
        qHistDelete(key, user.userId, getHeader()).then(Response => {
            histGetList(user.userId, selectedGroup.selectionId, activeComp.companyid, 5);
            toast.update(toastId, { render: "Conversation Deleted", autoClose: 1000 });
        });
    };

    // handle group item click
    const onXplrrPDFDismiss = () => {
        window.globalBase64String          = '';
        window.globalIntersectingEntries   = [];
        window.globalCurrentVisibleEntries = [];
        stopWigglePixel("stopWigglePixel_chat1");

        import.meta.env.DEV && console.log("PDF model closed, highlights reset.", isPDFModalOpen.fileId);


        // remove fid from url on pdf close
        const hshpat = window.location.hash.split("/");
        if ((hshpat[hshpat.length - 1])) {
            if (hshpat[hshpat.length - 1].startsWith(isPDFModalOpen.fileId)) {
                const newPath = hshpat.slice(0, -1).join("/");
                window.location.href = window.location.origin + window.location.pathname + newPath;
            }
        }


        setShouldPlayAudio(Math.random().toString(36).substring(2, 6));
        setVersionInvData(undefined);   // 🕰️ drop any transient version data on close
        setIsPDFModalOpen(prevConfig => ({
            ...prevConfig,
            isOpen: false,
            rndo: ''
        }));
    };

    // handle xplrr diff pdf dismiss
    const onXplrrDiffPDFDismiss = () => {
        window.globalBase64String = "";
        setShouldPlayAudio(Math.random().toString(36).substring(2, 6));
        setIsPDFDiffModalOpen(prevConfig => ({
            ...prevConfig,
            isOpen: false,
            rndo: ''
        }));
    };

    // remove citation active
    const removeCitationActive = () => {
        let prevEl = document.getElementById(clickedCitation.current || "placeholder_id");
        prevEl?.classList.remove("activeCitFlash");
    };

    // apply citation active
    const applyCitationActive = (elId: string | undefined) => {
        let obtainCitationElement = document.getElementById(elId || "placeholder_id");
        obtainCitationElement?.classList.add("activeCitFlash");
        clickedCitation.current = obtainCitationElement?.id;
    };

    // animate overlay highlight out, then clean up the exit class
    const overlayHighlightHide = (el: HTMLElement) => {
        if (!el.classList.contains(styles.overlayHighlightOn)) return;
        el.classList.remove(styles.overlayHighlightOn);
        el.style.removeProperty("--hl-delay");
        el.classList.add(styles.overlayHighlightOff);
        const cleanup = () => {
            el.classList.remove(styles.overlayHighlightOff);
            el.removeEventListener("animationend", onEnd);
            clearTimeout(fallback);
        };
        const onEnd = (e: AnimationEvent) => {
            if (e.target === el) cleanup();
        };
        el.addEventListener("animationend", onEnd);
        const fallback = window.setTimeout(cleanup, 600);
    };

    // animate overlay highlight in with a small stagger between blocks
    const overlayHighlightShow = (el: HTMLElement, idx: number) => {
        if (el.classList.contains(styles.overlayHighlightOn)) return;
        el.classList.remove(styles.overlayHighlightOff);
        el.style.setProperty("--hl-delay", `${Math.min(idx, 8) * 70}ms`);
        el.classList.add(styles.overlayHighlightOn);
    };

    // handle data highlight
    const onDataHighlight = (searchString: any) => {
        import.meta.env.DEV === true && console.log("‹data_highlight›", searchString);
        if (window.paragraphOverlayOn === true){
            const elements: HTMLCollectionOf<HTMLElement> = document.querySelectorAll(`div.${paragraphStyles.paragraphBox}`) as unknown as HTMLCollectionOf<HTMLElement>;

            const divs = [...elements].filter(div => div.title.includes(searchString));

            import.meta.env.DEV === true && console.log("‹data_highlight_divz›", divs);

            for (const el of elements) {
                if (!divs.includes(el)) overlayHighlightHide(el);
            }

            divs.forEach((div, idx) => overlayHighlightShow(div, idx));

        } else {
            setIsPDFModalOpen(prevConfig => ({
                ...prevConfig,
                searchString: searchString,
                rndo: Math.random().toString(36).substring(2, 6)
            }));
        }



    };

    // handle answer feedback send
    const onSendFeedback = (prps: gfeedback) => {
        fetch("/qFeedback", {
            method: "POST",
            headers: getHeader(),
            body: JSON.stringify(prps)
        }).then(Response => toast.success("Feedback Sent"));
        setAnswers(prevAnswers =>
            prevAnswers.map(([user, response]) =>
                response.interaction_guid === prps.interaction_guid ? [user, { ...response, pos: prps.pos }] : [user, response]
            )
        );
        let answrs = answers.map(([user, response]) =>
            response.interaction_guid === prps.interaction_guid ? [user, { ...response, pos: prps.pos }] : [user, response]
        );
        setTimeout(() => { histAdd(parseInt(activeConvoKey), user.userId, selectedGroup.selectionId, activeComp.companyid, answers[0][0], answrs)}, 2000);
    };

    // get group list
    const getGroupList = () => {
        return groupList && groupList.length > 0
            ? groupList.map(group => ({
                    selectedGroup: groupListToSelectedGroup(group)({} as gselectedgroup),
                    handleGroupListClick: (groupid: string, groupname: string, permissionlevel: number) => {
                        handleGroupListNav({
                            groupid: groupid,
                            groupname: groupname,
                            permissionlevel: permissionlevel,
                            filecount: group.filecount
                        });
                    }
                }))
        : [];
    };

    // switch xplrr module visibility
    const switchXplrrModuleVisibility = () => {
        if (xplrrChatVisible == false) {
            setXplrrChatVisible(true);
            setIsBlurredFull(true);
        }
    };

    // set is speaking status from speech output
    const setIsSpeakingStatusFromSpeechOutput = (bool: boolean) => {
        setTimeout(() => { setIsSpeaking(bool) }, 100);
    };

    // end conversation
    const convoEnd = (qna: gqasimplified[], convokey: string) => {
        let convoUpload: qconvoupload = {
            selectedGroup: selectedGroup,
            loggedInUser: loggedInUser,
            convo: qna,
            convoName: convokey
        };
        qUploadCCAConvo(convoUpload);
    };

    // main cca on/of switch
    const isOnCallback = (isOn: boolean) => {
        import.meta.env.DEV === true && console.log("‹convo_switch›", isOn);
        createEmptyConnectionState(); // dot cca main state init
        setIsConvoModeOn(prev => isOn);
        prepConnState(loggedInUser, selectedGroup, answers); // cca init state
    };

    // handle selected fids
    const handleSelectedFids = (fids: gfileuserselect[]) => {
        let fidSel = fids.filter(file => file.selected == true).map(file => file.fileid);
        if (fidSel?.length == window.globalFL.length) fidSel = [];
        setFidSelect(fidSel);
        setTransformedFileList(transformFileSelection(fileList, fidSel));
    };

    // render conversation template non-answer
    const renderConvoTempNonAnswer = (index: number, answr: [user: string, response: ChatAppResponse], totalAnswers: number) => {
        return (
            <div key={index}>
                <div className={`${isConvoModeOn && index == totalAnswers - 1 && styles.userMsgSpkr}`}>
                    <UserChatMessage message={answr[0]} />
                </div>
                <div className={styles.chatMessageGptMinWidth}>
                    <AnswerLoading loadingMsg={loadingMsg} shouldPulse={isConvoModeOn} totalAnswers={totalAnswers} />
                </div>
            </div>
        );
    };

    // send question to support
    const sendToSupport = (question: string) => {
        setSupportQuestion(question);
        setIsSupportModalOpen(true);
    };

    // handle send to support
    const handleSendToSupport = async (supportQuestion:string, userMail:string) => {
        try {
            const response = await fetch(supportFlowTarget, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    msg: supportQuestion,
                    mail: userMail != '' ? userMail : loggedInUser?.mail
                })
            });
            if (response.ok) {
                toast.success("Question sent to support successfully!");
                setIsSupportModalOpen(false);
                setSupportQuestion('');
            } else {
                toast.error("Failed to send question to support. Please try again.");
            }
        } catch (error) {
            console.error("Error sending question to support:", error);
            toast.error("Failed to send question to support. Please try again.");
        }
    };

    // chart regeneration handlers
    const handleChartRegenClick = useCallback((answer: ChatAppResponse, answerIndex: number, anchorEl: HTMLDivElement | null) => {
        setChartRegenCallout({ isOpen: true, answerIndex, anchorEl, answer });
    }, []);

    // chart regeneration dismiss
    const handleChartRegenDismiss = useCallback(() => {
        setChartRegenCallout({ isOpen: false, answerIndex: -1, anchorEl: null, answer: null });
        setChartInstruction('');
    }, []);

    // chart regeneration submit
    const handleChartRegenSubmit = useCallback(async () => {
        const { answer, answerIndex } = chartRegenCallout;
        if (!chartInstruction.trim() || !answer) return;

        // get fidselect from the answer or use all files
        let fids = answer.fidselect?.map(fid => parseInt(fid, 10)) || [];
        if (fids?.length === 0) fids = fileList.map((file:gfile) => parseInt(file.fileid));

        setIsChartLoading(true);
        setChartLoadingIndex(answerIndex);

        try {
            const useMermaid = selectedGroup.gen_opt?.use_mermaid === 1;
            const chartType  = useMermaid ? 'mermaid' : 'chartjs';
            const result     = await qGenChart(fids, chartInstruction, selectedGroup.selectionId, loggedInUser, chartType);
            import.meta.env.DEV === true && console.log('‹chart_regen_result›', result);
            if (result?.chartjs_json) {
                // update the answers array with the new chart (mermaid or chartjs — both live in chartjs_json)
                let newAnswers: [user: string, response: ChatAppResponse][] = []
                setAnswers(prev => {
                    newAnswers = [...prev];
                    if (newAnswers[answerIndex]) {
                        const updatedResponse = { ...newAnswers[answerIndex][1] };
                        const ctx = { ...updatedResponse.choices[0].context };
                        updatedResponse.choices = [{ ...updatedResponse.choices[0], context: ctx }];

                        // normalize existing chartjs_json to array and preserve string charts (e.g. mermaid syntax)
                        let existingCharts: any[] = [];
                        if (ctx.chartjs_json) {
                            if (Array.isArray(ctx.chartjs_json)) {
                                existingCharts = [...ctx.chartjs_json];
                            } else if (typeof ctx.chartjs_json === 'object') {
                                existingCharts = [ctx.chartjs_json];
                            } else if (typeof ctx.chartjs_json === 'string' && ctx.chartjs_json.trim()) {
                                const parsed = safeJsonParse(ctx.chartjs_json);
                                if (Array.isArray(parsed)) {
                                    existingCharts = parsed;
                                } else if (parsed && typeof parsed === 'object') {
                                    existingCharts = [parsed];
                                } else {
                                    existingCharts = [ctx.chartjs_json];
                                }
                            }
                        }
                        // append the new chart
                        ctx.chartjs_json = [...existingCharts, result.chartjs_json];

                        newAnswers[answerIndex] = [newAnswers[answerIndex][0], updatedResponse];
                    }

                    setStreamedAnswers(newAnswers)
                    import.meta.env.DEV === true && console.log('‹new_answers›', newAnswers);

                    // save to conversation history

                    if (activeConvoKey) {
                        const timeoutId = setTimeout(() => {
                            import.meta.env.DEV === true && console.log('‹seet›', result);
                            histAdd(
                                parseInt(activeConvoKey),
                                user.userId,
                                selectedGroup.selectionId,
                                activeComp.companyid,
                                newAnswers[answerIndex][0],
                                newAnswers
                            )
                        }, 500);

                    }
                    return newAnswers;
                });
            }
        } catch (e) {
            console.error('‹errr_regen_chart›', e);
            toast.error("Failed to generate chart. Please try again.");
        } finally {
            setIsChartLoading(false);
            setChartLoadingIndex(-1);
            handleChartRegenDismiss();
        }
    }, [chartRegenCallout, chartInstruction, selectedGroup.selectionId, activeConvoKey, fileList]);

    // render answer main
    const renderAnswer = (index: number, answr: [user: string, response: ChatAppResponse], totalAnswers: number) => {
        return (
            <div key={index}>
                <div className={`${isConvoModeOn && index == totalAnswers - 1 && styles.userMsgSpkr}`}>
                    <UserChatMessage message={answr[0]} dateCode={answr[1]["datecode"]} />
                </div>
                {isConvoModeOn && index == totalAnswers - 1 && (
                    <canvas data-key={`${activeConvoKey}${index}`} ref={msgCanvasRef} className={styles.msgviscanvas}></canvas>
                )}
                <div className={styles.answerContainer}>
                    {answr && answr.length > 0 && selectedGroup.assistanttype == assistantCodes.cca && (
                        <div className={styles.active_scenario_id}>{answr[1].active_scenario_id?.substring(0, 30)}</div>
                    )}
                    <div className={styles.chatMessageGpt}>
                        <Answer
                            key={index}
                            index={index}
                            answer={answr[1]}
                            isLoading={isLoading}
                            isStreaming={isStreaming}
                            speakStatus={{isSpeaking: isSpeaking, isPaused: isSpeechPaused}}
                            selectedGroup={selectedGroup}
                            isSBS={config.showDocLibInChatTab}
                            isReverseAnswerList={selectedGroup.assistanttype == assistantCodes.prd}
                            totalAnswers={selectedGroup.assistanttype == assistantCodes.prd ? 1 : totalAnswers}
                            showFollowupQuestions={config.useSuggestFollowupQuestions && answers.length - 1 === index}
                            activeConvoKey={activeConvoKey}
                            onSendFeedback={onSendFeedback}
                            manageSpeechPause={(val: boolean) => setIsSpeechPaused(val)}
                            onFollowupQuestionClicked={q => makeApiRequest(q)}
                            clickedCitation={clickedCitation.current || "placeholder_cit_id"}
                            onCitationClicked={(filePath: string, integratedCitation: string | null, el: HTMLElement | null, openSBS?: boolean) => {
                                manageCitationOpen(filePath, integratedCitation, index, el, openSBS);
                            }}
                            sendToSupport={sendToSupport}
                            onChartRegenClick={handleChartRegenClick}
                        />
                    </div>
                </div>
            </div>
        );
    };

    // group options for space switcher
    const groupOptions = useMemo(() => {
        return groupList.map(
            (item: { groupid: string; groupname: string; userid: string; permissionlevel: number }) => ({
                key: item.groupid,
                text: item.groupname,
                memberlevel: item.permissionlevel
            })
        )
    }, [groupList])

    const toggleCCAChatGetTarget = () => {
        qGetUP(loggedInUser, selectedGroup.def_campaign_id).then(resp => {
            window.global_u_cmp_obj = resp as camp_c_onf[];
            setIsCcaChat(prev => !prev)
        })
    }

    return (
        <ThemeProvider theme={customTheme}>
            <div className={styles.container} id={"rro"}>

                <ToastContainer className={styles.toastCont} position="top-center" pauseOnHover transition={Bounce} style={{ zIndex: 99999999, borderRadius: "8px", fontFamily: "Urbanist" }} />

                {isConvoModeOn == true && (
                    <SpeechOutput
                        chunk={convActvSentnce.current}
                        pauseSpeak={isSpeechPaused}
                        isSpeakingCallback={(val: boolean) => { setIsSpeakingStatusFromSpeechOutput(val)} }
                        msgCanvasRef={msgCanvasRef}
                        selectedGroup={selectedGroup}
                        activeConvoKey={activeConvoKey}
                    />
                )}

                {/* 🔝 header */}
                {isIframe == 0 ? (
                    <div className={styles.headerMain}>
                        <div className={styles.headerSubMain}>
                            <div className={styles.commandsContainer}>
                                <div className={styles.gridDots} onClick={toggleSpacePanel}>
                                    {isSpacePanelLoading ? (
                                        <div className={styles.spacePanelLoadingIcon}>
                                            <Spinner size={SpinnerSize.medium} ariaLive="assertive" />
                                        </div>
                                    ) : (
                                        <HiOutlineViewList size={25} />
                                    )}
                                </div>

                                {/* banner */}
                                <h2 className={styles.leftLogo} onClick={navGrpTab}>
                                    {isLib != locationCodes.grp ? (
                                        <div className={styles.homeIconGridDots}>
                                            <TbGridDots />
                                        </div>
                                    ) : null}
                                </h2>
                                {/* left header buttons */}
                                {checkWeAreInGeneralPlace(isLib) == false && (
                                    <div>
                                        <div className={styles.vertLineHeaderWhitelabel} />
                                        <div className={styles.headSpaceContainerWhiteLabel}>
                                            <div className={`${config.showDocLibInChatTab == false ? styles.headSpaceName : styles.headSpaceNameSBS}`} onClick={navChatTab}>
                                                <span>{selectedGroup.selectionText} </span>
                                            </div>
                                            {selectedGroup.hideroottabs != 1 &&
                                            <div className={styles.headSpaceButts}>
                                                <SettingsButton
                                                    className={`${styles.settingsButton} ${isLib == locationCodes.chat ? styles.settingsButtonActive : ""}`}
                                                    onClick={navChatTab}
                                                    buttonText="Chat"
                                                    iconId="PiChatTeardropDotsBold"
                                                />
                                                {((selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.permissionlevel >= 2) || (selectedGroup.assistanttype != assistantCodes.cca)) && (
                                                    <SettingsButton
                                                        className={`${styles.settingsButton} ${isLib == locationCodes.lib ? styles.settingsButtonActive : ""}`}
                                                        onClick={navLibTab}
                                                        buttonText={activeComp.permissionlevel > 1 ? "Manage" : "Content"}
                                                        iconId="TbSettings2"
                                                    />
                                                )}

                                                {/* share button */}
                                                <div ref={addUserButtonRef}></div>
                                                {selectedGroup.permissionlevel >= 2 ? (
                                                    <div className={styles.headSpaceButsShare} onClick={() => setIsShareCalloutVisible(!isShareCalloutVisible)}>
                                                        <IoShareSocialOutline />
                                                    </div>
                                                ) : null}
                                            </div>
                                            }
                                        </div>
                                        <div className={styles.headMenu}/>
                                    </div>
                                )}

                                {/* split chat-pdf */}
                                <div className={styles.commandsC} id="addSpcBttnID">
                                    {checkWeAreInGeneralPlace(isLib) == false &&
                                        isElementVisible("#dLM") == false &&
                                        config.showDocLibInChatTab == true == true && (
                                            <TooltipHost content="Close Side-by-Side View" directionalHint={DirectionalHint.topCenter}>
                                                <IconButton onClick={toggleChatWithDocs} className={styles.SBSIconWrap}>
                                                    <div className={styles.closeSBSPanelIcon}>
                                                        <LuPanelRightClose size={22}></LuPanelRightClose>
                                                    </div>
                                                </IconButton>
                                            </TooltipHost>
                                        )}
                                </div>

                                {/* user account + feedback direct */}
                                {selectedGroup.assistanttype == assistantCodes.cca && isLib == locationCodes.chat && selectedGroup.line_config?.twi_lmapp && selectedGroup.line_config?.twi_lmapp != "" ? (
                                    <div  onClick={() => {toggleCCAChatGetTarget()}} className={styles.ccaChatToggle}>
                                        <TooltipHost content={isCcaChat ? "Call Center Text Mode (beta)" : "Voice Mode"} id="myTooltipId" calloutProps={{ gapSpace: 0 }} delay={TooltipDelay.zero}>
                                            {isCcaChat ? <IoMicOffOutline size={22}/> : <IoMicOutline size={22}/>}
                                        </TooltipHost>
                                    </div>
                                ) : (
                                    <div ref={feedbackDirectButtonRef} className={styles.feedbackDirectContainer}>

                                        {/* feedback button */}
                                        <img
                                            src={feedbackDirectIcon}
                                            alt="Feedback"
                                            width={28}
                                            height={28}
                                            className={styles.feedbackIconButton}
                                            onClick={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setIsFeedbackDirectOpen(true);
                                            }}
                                            onTouchEnd={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setIsFeedbackDirectOpen(true);
                                            }}
                                            style={{ cursor: "pointer", touchAction: "manipulation" }}
                                        />
                                    </div>
                                )}

                                <div id="userPhoto" onClick={() => setIsAccountMenuVisible(true)} className={styles.iconCircle}>
                                    <div className={`${styles.iconCircleIcon} ${isAccountMenuVisible == true ? styles.iconCircleIconActive : ""}`}>
                                        {config.experimentalFeatures ? <DicebearThumb seed={garble(loggedInUser.mail, 42)} size={30} /> : <FiUser size={32} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* ℹ️ context account menu */}
                {isAccountMenuVisible && (
                    <ContextualMenu items={accMenuItems} target={document.getElementById("userPhoto")} onDismiss={() => setIsAccountMenuVisible(false)} />
                )}

                {/* ✨ main area */}
                <div className={styles.chatRoot}>
                    {/* iframe ⇒ top blur */}
                    {isIframe == 1 && <div className={styles.blurBackForIframe}></div>}

                    {/* main container */}
                    <div className={styles.chatContainer}>

                        {/* iframe ⇒ header */}
                        {isIframe == 1 && (
                            <div className={styles.iframeAccountOptions}>

                                {/* iframe ⇒ header logo */}
                                <div
                                    className={`${styles.linkImgIframe} ${config.isDark ? styles.linkDarkIframe : ""}`}
                                    onClick={() => { window.open(window.location.href.replace("ifrm=true", "").replace("&A=1", ""), "_blank", "noopener,noreferrer") }}
                                >
                                    <img className={styles.kgnfMainLogo} src={kognifyLogo} height="30px" />
                                </div>
                                {/* iframe ⇒ user avatar */}
                                <div id="userPhoto" onClick={() => setIsAccountMenuVisible(true)} className={styles.iconCircleIframe}>
                                    <div className={`${styles.iconCircleIcon} ${isAccountMenuVisible == true ? styles.iconCircleIconActive : ""}`}>
                                        {config.experimentalFeatures == true ? (
                                            <DicebearThumb seed={garble(loggedInUser.mail)} size={32} />
                                        ) : (
                                            <FiUser size={32} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* library */}
                        {isLib == locationCodes.lib && initLoad == false ? (

                            // top menu tabs
                            <div className={styles.chatEmptyState} style={{ width: "100vw", height: "100vh" }}>
                                <Pivot
                                    onLinkClick={(item: any) => {handlePivotItemClick(item, selectedGroup.hideroottabs)}}
                                    styles={selectedGroup.hideroottabs != 1 ? libPivotStyles : libPivotHiddenStyles}
                                    className={styles.libPivotMain}
                                    defaultSelectedKey="Sources"
                                >
                                    <PivotItem headerText='' itemKey='back' onRenderItemLink={() => (
                                        <div className={styles.backPivotItemIconCont}>
                                            <MdArrowBackIos size={20} />
                                        </div>
                                    )}/>
                                    <PivotItem
                                        headerText={isMobileWidth ? "📄" : "Content"}
                                        itemKey="Sources"
                                        onRenderItemLink={() => (
                                            isMobileWidth ? (
                                                <div className={styles.backPivotItemIconCont} title="Content"><BsCardList size={20} /></div>
                                            ):(
                                                <div className={styles.backPivotItemIconCont} title="Content">
                                                    <span>{selectedGroup.assistanttype == assistantCodes.ipa && selectedGroup.hideroottabs == 1 ? "Your Invoices" : "Content"}</span>
                                                </div>
                                            )
                                        )}
                                    >
                                        {/* library component */}
                                        <div key={`kk_${fileCount}`} className={styles.detailsListWrapper}>
                                            <DetailsListDocumentsExample
                                                fileList={fileCount > -1 ? fileList : undefined}
                                                selectedGroup={selectedGroup}
                                                selectionPass={includeCategory}
                                                onSelectionChange={handleSelectionChange}
                                                groupList={groupOptions}
                                                updateCatsState={updateCatsState}
                                                fileSpaceChangeTrigger={() => qGetSpaceFiles(false, true)}
                                                getOFromListVal={selectedGroup.permissionlevel}
                                                openSpacesEditPanel={() => setIsSpaceEditModalOpen(true)}
                                                openSpacesAnalyticsPanel={openSpacesAnalyticsPanel}
                                                user={user}
                                                loggedInUser={loggedInUser}
                                                onDelFile={() => qGetSpaceFiles(false, true)}
                                                onCitationClicked={(filePath: string, integratedCitation: string | null) => onShowCitation(filePath, integratedCitation, 0)}
                                                onCompareClicked={onCompareClicked}
                                                companyId={activeComp.companyid}
                                                listRefreshRequest={listRefreshRequest}
                                                onVersionInvoiceOpen={onOpenVersionInvoice}
                                            />
                                        </div>
                                    </PivotItem>
                                    {
                                        selectedGroup.permissionlevel > 2 && (
                                            <PivotItem
                                                headerText={isMobileWidth ? "🔒" : "Permissions"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont} title="Permissions"><TbUserSquareRounded size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont} title="Permissions"><span>Permissions</span></div>
                                                    ))
                                                }
                                            >
                                                {/* user permissions component */}
                                                <div className={styles.settingsPivotPermissions}>
                                                    <SpaceUserListV2
                                                        users={compMbrshps}
                                                        activeComp={activeComp.companyid}
                                                        spaceSecurityUpdate={userMngmntUpdate}
                                                        companies={compFlatList}
                                                    />
                                                </div>
                                            </PivotItem>
                                        )
                                    }
                                    {
                                        selectedGroup.permissionlevel > 2 && (
                                            <PivotItem
                                                headerText={isMobileWidth ? "⚙️" : "AI Config"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont} title="AI Configuration"><RiSettings4Line size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont} title="AI Configuration"><span>AI Config</span></div>
                                                    ))
                                                }
                                            >
                                                {/* space settings component */}
                                                <div className={styles.setPivWrap}>
                                                    <div className={styles.settingsPivotSpace}>
                                                        <SpaceEditForm selectedGroup={selectedGroup} onEditSpaceSave={onEditSpaceSave} onGroupDel={onGroupDel} />
                                                    </div>
                                                </div>
                                            </PivotItem>
                                        )
                                    }
                                    {
                                        selectedGroup.permissionlevel > 2 && selectedGroup.assistanttype == assistantCodes.ipa ? (
                                            <PivotItem
                                                headerText={isMobileWidth ? "✨" : "Invoice Config"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont}  title="Invoice Configuration"><LuBrainCircuit size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont}  title="Invoice Configuration"><span>Invoice Config</span></div>
                                                    ))
                                                }
                                            >
                                                {/* inv config component */}
                                                <div className={styles.setPivWrap}>
                                                    <div className={styles.settingsPivotInvoiceConfig}>
                                                        <FieldSelectionForInvoices
                                                            selectedGroup={selectedGroup}
                                                            loggedInUser={loggedInUser}
                                                            fileList={window.globalFL.filter((file: gfile) => file.doc_category == 'data')}
                                                            onEditSpaceSave={onEditSpaceSave}
                                                        />
                                                    </div>
                                                </div>
                                            </PivotItem>
                                        ) : selectedGroup.permissionlevel > 2 && selectedGroup.assistanttype == assistantCodes.dpa ? (
                                            <PivotItem
                                                headerText={isMobileWidth ? "✨" : "Process Config"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont} title="Processing Configuration"><LuBrainCircuit size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont} title="Processing Configuration"><span>Process Config</span></div>
                                                    ))
                                                }
                                            >
                                                {/* dpa config component */}
                                                <div className={styles.setPivWrap}>
                                                    <div className={styles.processConfigSettingsPivot}>
                                                        <DocFieldSettings
                                                            selectedGroup={selectedGroup}
                                                            loggedInUser={loggedInUser}
                                                            onEditDocExtractionDone={onEditSpaceSave}
                                                            fileList={window.globalFL.map((file: gfile) => ({ fileid: file.fileid, name: file.name }))}
                                                            purpose="doc"
                                                        />
                                                    </div>
                                                </div>
                                            </PivotItem>
                                        ) : selectedGroup.permissionlevel > 2 && selectedGroup.assistanttype == assistantCodes.cca && (
                                            <PivotItem
                                                headerText={isMobileWidth ? "📲" : "Call Center"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? ( // icon
                                                        <div className={styles.backPivotItemIconCont} title="Call Center Settings"><MdSettingsPhone size={22} /></div>
                                                    ):( // sign
                                                        <div className={styles.backPivotItemIconCont} title="Call Center Settings"><span>Call Center</span></div>
                                                    ))
                                                }
                                            >
                                                <div className={styles.setPivWrap}>
                                                    <div className={styles.settingsPivot}>
                                                        <CallAssistantSettings
                                                            selectedGroup={selectedGroup}
                                                            fileList={window.globalFL.map((file: gfile) => ({ fileid: file.fileid, name: file.name }))}
                                                            loggedInUser={loggedInUser}
                                                            onEditDocExtractionDone={onEditSpaceSave}
                                                            purpose="call"
                                                        />
                                                    </div>
                                                </div>
                                            </PivotItem>
                                        )
                                    }

                                    {/* campaigns - cca only */}
                                    {
                                        selectedGroup.assistanttype == assistantCodes.cca && selectedGroup.permissionlevel > 2 && selectedGroup.campaigns_enabled == 1 && (
                                            <PivotItem
                                                headerText={isMobileWidth ? "📋" : "Campaigns"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont} title="Campaigns"><MdCampaign size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont} title="Campaigns"><span>Campaigns</span></div>
                                                    ))
                                                }
                                            >
                                                <div className={styles.setPivWrap}>
                                                    <div className={styles.settingsPivot}>
                                                        <CampaignManager
                                                            selectedGroup={selectedGroup}
                                                            loggedInUser={loggedInUser}
                                                            onGroupUpdate={(patch) => setSelectedGroup(prev => ({ ...prev, ...patch }))}
                                                            onInviteMember={inviteCampaignMember}
                                                            fileList={fileList}
                                                        />
                                                    </div>
                                                </div>
                                            </PivotItem>
                                        )
                                    }

                                    {/* analytics - per space convo and sync */}
                                    {
                                        selectedGroup.permissionlevel > 2 && (
                                            <PivotItem
                                                headerText={isMobileWidth ? "📶" : "Analytics"}
                                                onRenderItemLink={() => (
                                                    isMobileWidth ? (
                                                        <div className={styles.backPivotItemIconCont} title="Analytics"><IoMdAnalytics size={22} /></div>
                                                    ):(
                                                        <div className={styles.backPivotItemIconCont} title="Analytics"><span>Analytics</span></div>
                                                    ))
                                                }
                                            >
                                                {/* analytics component */}
                                                <div className={styles.anltxc_xt}>
                                                    <AnalyticsConvoList selectedGroup={selectedGroup} loggedInUser={loggedInUser} aggC={0} activeComp={activeComp} />
                                                </div>
                                            </PivotItem>
                                        )
                                    }
                                </Pivot>
                            </div>
                        ) : isLib == locationCodes.chat && selectedGroup?.assistanttype != assistantCodes.prd && initLoad == false ? (

                            // chat ⇒ not product assistant
                            <div className={config.showDocLibInChatTab == true ? styles.SBSWrap : isIframe==1 ? styles.ChatOnlyWrapIFrame : styles.ChatOnlyWrap}>

                                {/* chat ⇒ not product assistant */}
                                <div className={config.showDocLibInChatTab == true ? styles.sideBySideUnderWrapSBS : styles.chatFullScreenUnderWrap}>
                                    <div ref={xplrrMsgStrm} className={config.showDocLibInChatTab == true ? styles.chatMessageStreamSBS : styles.chatFullScreenMessageStream}>
                                        <div className={config.showDocLibInChatTab == true ? styles.chatMessageStreamInnerSBS : styles.chatMessageStreamInner}>

                                            {(isStreaming ? streamedAnswers : !isStreaming ? answers : [])?.map((answr, index) => {
                                                return answr[1]?.discard != true
                                                    ? renderAnswer(index, answr, streamedAnswers?.length ?? answers.length)
                                                    : renderConvoTempNonAnswer(index, answr, streamedAnswers?.length ?? answers.length);
                                            })}

                                            {isLoadingRef.current && (
                                                <>
                                                    <UserChatMessage message={lastQuestionRef.current} />
                                                    <div className={styles.chatMessageGptMinWidth}>
                                                        <AnswerLoading loadingMsg={loadingMsg} classStr="prepTextStyle" />
                                                    </div>
                                                </>
                                            )}
                                            {error ? (
                                                <>
                                                    <UserChatMessage message={lastQuestionRef.current} />
                                                    <div className={styles.chatMessageGptMinWidth}>
                                                        <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                                    </div>
                                                </>
                                            ) : null}

                                            {!isStreaming && !isLoading && !error && answers.length == 0 && loadingChatModeSwitch == false ? (
                                                <>
                                                    <div className={styles.chatMessageGptMinWidthHI}>
                                                        {selectedGroup.assistanttype == assistantCodes.prd ? (
                                                            <AnswerDocs
                                                                selectedGroup={selectedGroup}
                                                                fileList={fileList}
                                                                loggedInUser={loggedInUser}
                                                                onCitationClicked={(filePath: string, integratedCitation: string | null) =>
                                                                    onShowCitation(filePath, integratedCitation, 0)
                                                                }
                                                            />
                                                        ) : (
                                                            <AnswerHi
                                                                content={
                                                                    selectedGroup.custgreetingmessage
                                                                        ? `${selectedGroup.custgreetingmessage} \n ${greetingMessageHtml}`
                                                                        : `${defaultGreetingsMessage} \n ${greetingMessageHtml}`
                                                                }
                                                                selectedGroup={selectedGroup}
                                                            />
                                                        )}
                                                    </div>
                                                </>
                                            ) : loadingChatModeSwitch == true ? (
                                                <div className={styles.chatMessageGptMinWidthHI}>
                                                    <div className={styles.typingDots}>
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            ) : null}

                                            <div ref={chatMessageStreamEnd} />
                                        </div>
                                    </div>
                                    {/* scoped content file list */}
                                    {selectedGroup.assistanttype != assistantCodes.cca && fidSelect.length > 0 && (
                                        <div className={styles.stackfilterList} style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-start", gap: "2px" }}>
                                            {transformedFileList
                                                .filter((file: gfileuserselect) => file.selected)
                                                .map((file, index) => (
                                                    <TooltipHost
                                                        key={`filtfi${file.fileid}`}
                                                        content={
                                                            <div className={styles.fileThumbTooltip}>
                                                                <div className={styles.fileTooltipContent}>{file.name}</div>
                                                                <img style={{ maxWidth: "300px" }} src={thumbMap.get(file.fileid) ?? ""} />
                                                            </div>
                                                        }
                                                        closeDelay={500}
                                                    >
                                                        <div
                                                            onClick={ () => {onShowCitation(`${file.name}#page=1_fid=${file.fileid}`, null, 0) }}
                                                            key={`filtfi${file.fileid}`}
                                                            style={{ flex: "1 1 calc(50% - 8px)", paddingRight: "5px", paddingTop: "2px" }}
                                                        >
                                                            <Text variant="small" className={styles.filterFidText} styles={textChatFileFilterStyles}>
                                                                {file.name}
                                                            </Text>
                                                        </div>
                                                    </TooltipHost>
                                                ))}
                                        </div>
                                    )}

                                    <div className={config.showDocLibInChatTab == true ? styles.chatInputSBS : styles.chatInput}>

                                        {/* question input ⇒ chat or twilio */}
                                        <div className={styles.stackfilterContainer}/>

                                        <div className={styles.questionInputContainer} id={`R_${randoCcaCampRefresh}`}>

                                            {/* chat input */}
                                            {(selectedGroup.assistanttype != assistantCodes.cca || isCcaChat == true) ? (
                                                <QuestionInput
                                                    clearOnSend={true}
                                                    isStreaming={isStreaming}
                                                    disabled={isLoading}
                                                    placeholder={window.innerWidth < 400 ? "Start..." : "Start a conversation..."}
                                                    permissionLevel={selectedGroup.permissionlevel}
                                                    selectedGroup={selectedGroup}
                                                    lTiers={lTiers || []}
                                                    msgLmtHit={msgLmtHit}
                                                    loggedInUser={loggedInUser}
                                                    onSend={makeApiRequest}
                                                    updateCatsState={updateCatsState}
                                                    isCancellingMidway={handleIsCancellingMidway}
                                                    toggleLeftPanel={toggleLeftPanel}
                                                    newConverson={newConverson}
                                                    listRefreshRequest={listRefreshRequest}
                                                    isOnCallback={isOnCallback}
                                                    convoEnd={convoEnd}
                                                    isSpeaking={isSpeaking}
                                                    isSpeechPaused={isSpeechPaused}
                                                    lastMessage={lastMessage}
                                                    activeConvoKey={activeConvoKey}
                                                    question_and_answers_list={question_and_answers_list}
                                                    convo_discard_stamp={convo_discard_stamp}
                                                    fileselection={transformedFileList}
                                                    handleSelectedFids={handleSelectedFids}
                                                    onCitationClicked={(filePath: string, integratedCitation: string | null) =>
                                                        onShowCitation(filePath, integratedCitation, 0)
                                                    }
                                                />
                                            ) : (
                                                <div className={styles.questionInputCCA}>
                                                    <ClearChatButton className={styles.commandButtonTwo} onClick={() => newConverson()} />

                                                    {/* show chat history button */}
                                                    <TogglePanelButton
                                                        className={styles.commandButton}
                                                        onClick={() => toggleLeftPanel()}
                                                        text=""
                                                        iconType={List28Regular}
                                                        tooltipText="View your Conversation History"
                                                    />
                                                    {selectedGroup.line_config && selectedGroup.line_config.twi_lmapp != "" && (
                                                        <div className={styles.anltxc}>
                                                            <TwiLMWebCCA
                                                                selectedGroup={selectedGroup}
                                                                loggedInUser={loggedInUser}
                                                                activeConvoKey={activeConvoKey}
                                                                histGetByKey={histGetByKey}
                                                                newConversation={newConverson}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* side-by-side chat */}
                                {config.showDocLibInChatTab == true ? (
                                    <div className={styles.xplrrPDFZ_SBS}>
                                        <XplrrPDFSideByChat
                                            startPage={isPDFModalOpen.startPage}
                                            citationFileId={isPDFModalOpen.defaultFile}
                                            xplrrCitationChangeCallback={xplrrCitationChangeCallback}
                                            fileId={isPDFModalOpen.fileId}
                                            refPageNum={isPDFModalOpen.refPageNum}
                                            isCitation={isPDFModalOpen.isCitation}
                                            rndo={isPDFModalOpen.rndo}
                                            searchString={isPDFModalOpen.searchString}
                                            activeGroupState={isPDFModalOpen.activeGroupId}
                                            fileList={fileList}
                                            shouldPlayAudio={shouldPlayAudio}
                                        />
                                    </div>
                                ) : (
                                    <div className={styles.underInput}>
                                        <div className={styles.chatInfo}></div>
                                    </div>
                                )}
                            </div>
                        ) : // chat ⇒ product assistant bot
                        (isLib == locationCodes.chat && selectedGroup?.assistanttype == assistantCodes.prd) ||
                          window.location.href?.indexOf("ifrm=2") > 0 == true ||
                          isIframe == 2 ? (
                            <div className={styles.ChatOnlyWrap}>

                                {/* product doc blur */}
                                <div className={isBlurredFull == true ? styles.blurBackFull : ""}>
                                    <div
                                        className={isBlurredFull == true ? styles.blurBackFull : ""}
                                        onClick={() => {
                                            setIsBlurredFull(false);
                                            setXplrrChatVisible(false);
                                        }}
                                    ></div>
                                </div>

                                {/* product doc chat */}
                                <div className={styles.xplrrChatWrp}>
                                    <div className={styles.xplrrChatInput} onClick={() => switchXplrrModuleVisibility()}>

                                        {/* question input container */}
                                        <div
                                            className={
                                                xplrrChatVisible == true
                                                    ? isIframe && isIframe > 0
                                                        ? styles.questionInputXplrrWideIframe
                                                        : styles.questionInputXplrrWide
                                                    : isIframe && isIframe > 0
                                                    ? styles.questionInputXplrrWideIframe
                                                    : styles.questionInputXplrr
                                            }
                                        >

                                            {/* question input iframe ⇒ product bot */}
                                            <QuestionInputXplrr
                                                clearOnSend
                                                placeholder="Ask a question..."
                                                disabled={isLoading}
                                                onSend={(question: string) => {makeApiRequest(question)}}
                                                toggleLeftPanel={toggleLeftPanel}
                                                newConverson={newConverson}
                                            />
                                        </div>

                                        {/* product doc chat slide down */}
                                        {xplrrChatVisible == true ? (
                                            <div ref={xplrrMsgStrm} className={isIframe == 2 ? styles.xplr_chatMessageStreamProductAssist : styles.xplr_chatMessageStream}>
                                                <div className={isIframe == 2 ? styles.xplr_chatMessageStreamInnerProductAssist : styles.xplr_chatMessageStreamInner}>
                                                    <div ref={chatMessageStreamEnd} />
                                                    {isLoading && (
                                                        <>
                                                            <UserChatMessage message={lastQuestionRef.current} />
                                                            <div className={styles.chatMessageGptMinWidthProductAssist}>
                                                                <AnswerLoading loadingMsg={loadingMsg} />
                                                            </div>
                                                        </>
                                                    )}
                                                    {!!error && (
                                                        <>
                                                            <UserChatMessage message={lastQuestionRef.current} />
                                                            <div className={styles.chatMessageGptMinWidth}>
                                                                <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                                            </div>
                                                        </>
                                                    )}
                                                    {streamedAnswers.length < 1 && isStreaming != true && (
                                                        <div className={styles.chatMessageGptMinWidthHI}>
                                                            {/* slide down doc list */}
                                                            <AnswerDocs
                                                                selectedGroup={selectedGroup}
                                                                fileList={fileList}
                                                                loggedInUser={loggedInUser}
                                                                onCitationClicked={(filePath: string, integratedCitation: string | null) =>
                                                                    onShowCitation(filePath, integratedCitation, 0)
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                    {(isStreaming ? streamedAnswers : !isStreaming ? answers : [])
                                                        .slice()
                                                        .reverse()
                                                        .map((answr, index) => renderAnswer(index, answr, streamedAnswers?.length ?? 0))}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* product documentation external file list */}
                                    {isIframe == 0 ? (
                                        <div className={styles.xplrrChatFilelist}>
                                            <Stack horizontal tokens={{ childrenGap: 20 }} className={styles.prdAssistantFileList}>
                                                {fileList.slice(0, 20).map((file, index) => (
                                                    <Stack.Item key={index}>
                                                        <DocumentCard
                                                            key={index}
                                                            type={DocumentCardType.normal}
                                                            className={styles.hiDocCard}
                                                            onClick={() => {onShowCitation(`${file.name}#page=1_fid=${file.fileid}`, null, 0)}}
                                                        >
                                                            <DocumentCardTitle title={removeExtension(file.name)} shouldTruncate={true} className={styles.docCardTitle}/>
                                                            <DocumentCardPreview
                                                                key={index}
                                                                previewImages={[
                                                                    {
                                                                        previewImageSrc: thumbnailUrls[index],
                                                                        imageFit: 2,
                                                                        name: file.name
                                                                    }
                                                                ]}
                                                                styles={prdAssistantExternalFileListStyle}
                                                            />
                                                        </DocumentCard>
                                                    </Stack.Item>
                                                ))}
                                            </Stack>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : isLib == locationCodes.grp ? (
                            <div className={styles.grpScrn}>
                                <div className={styles.spaceCards}>
                                    {noGroupsShared == true ? (
                                        <div>
                                            <div className={styles.spaceSplashGreetings}>
                                                <div className={styles.hi}>Hi{user.name ? `, ${user.name}` : ""}!</div>
                                                <div className={styles.hiAskAnything}>It seems there are no Assistants shared with you.</div>
                                            </div>
                                            <div>
                                                <NoSpacesCard
                                                    onCreateClicked={() => setIsSpaceModalOpen(true)}
                                                    showCreateSpacePrompt={true}
                                                    activeComp={activeComp}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.groupCardsListOutsideWrap}>
                                            {/* assistant cards */}
                                            <div className={styles.spaceSplashGreetings}>
                                                <img src={kognifyLogo} className={styles.kgnfLogoCenter} height="58px"></img>
                                                <div className={styles.hiAskAnything}>Your Assistants</div>
                                            </div>
                                            <GroupCardsList
                                                key={selectedGroup.oid}
                                                grL={getGroupList()}
                                                onNewGroupClick={onNewGroupClick}
                                                compLvl={activeComp.permissionlevel}
                                                permissionLevelsMap={permissionLevels}
                                                newSpacePyro={newSpacePyro}
                                                user={user}
                                                activeComp={activeComp}
                                                navChatLib={navChatLib}
                                            />
                                        </div>
                                    )}
                                </div>
                                {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                                    <div className={styles.contactUsMailMainScreen} >
                                        <TooltipHost content={helpMailTooltip} styles={tooltipHostStyles} directionalHint={DirectionalHint.topCenter}>
                                            <a href="mailto:hey@kgnfy.com">
                                                <div className={styles.contactIcon}>
                                                    <LuMailQuestion size={22} color="#FFA239" />
                                                </div>
                                            </a>
                                        </TooltipHost>
                                    </div>
                                )}
                            </div>
                        ) : // account settings
                        isLib === locationCodes.acc ? (
                            <div>
                                <div className={styles.accountInfoWrap}>
                                    <AccountInfo
                                        key={groupList?.length}
                                        groups={groupList}
                                        user={user}
                                        lTiers={lTiers || []}
                                        activeComp={activeComp}
                                        selectedGroup={selectedGroup}
                                    />
                                </div>
                            </div>
                        ) : // administrative
                        isLib === locationCodes.adm ? (
                            /* administrative menu */
                            <div>
                                <Pivot onLinkClick={handleAdmPivotItemClick} className={styles.spaceSecurityPivot} styles={chatAdmPivotStyles} defaultSelectedKey="usersAdm">
                                    <PivotItem
                                        headerText=""
                                        itemKey="back"
                                        onRenderItemLink={() => (
                                            <div className={styles.backPivotItemIconCont}>
                                                <MdArrowBackIos size={20} />
                                            </div>
                                        )}
                                    />
                                    <PivotItem headerText="Users" itemKey="usersAdm" className={styles.settingsPivot} key={allUsrs?.length || -1}>
                                        <UserList
                                            key={allUsrs.length || -1}
                                            users={allUsrs}
                                            activeComp={activeComp}
                                            userMngmntUpdate={userMngmntUpdate}
                                            companies={compFlatList}
                                            loggedInUser={loggedInUser}
                                            src='pivot'
                                        />
                                    </PivotItem>
                                    <PivotItem headerText="Companies" itemKey="compAdm">
                                        <div className={styles.settingsPivot}>
                                            <CompList
                                                comps={compFlatList}
                                                newActiveComp={handleCompChange}
                                                activeComp={activeComp}
                                                loggedInUser={loggedInUser}
                                                src="full"
                                            />
                                        </div>
                                    </PivotItem>
                                    <PivotItem headerText="Company Administration" itemKey="compSett">
                                        <div>
                                            <h3 className={styles.modalTitle}>{activeComp.companyname}</h3>
                                            <CompEditForm activeComp={activeComp} selectedGroup={selectedGroup} />
                                        </div>
                                    </PivotItem>
                                    <PivotItem headerText="Company Analytics" itemKey="compAnalytics">
                                        <div className={styles.anltxc_co}>
                                            <AnalyticsConvoList selectedGroup={selectedGroup} loggedInUser={loggedInUser} aggC={1} activeComp={activeComp} />
                                        </div>
                                    </PivotItem>
                                </Pivot>
                            </div>
                        ) : noMembership == true ? (
                            <div>
                                <NoSpacesCard onCreateClicked={() => setIsSpaceModalOpen(true)} showCreateSpacePrompt={false} activeComp={activeComp} />
                            </div>
                        ) : (
                            <div className={styles.loadingIndicatorCenterScreen}>
                                <div className={styles.typingDots}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* user settings from account menu */}
                    <Panel
                        headerText="Settings"
                        className={styles.panelSettingsPanel}
                        isOpen={isConfigPanelOpen}
                        isLightDismiss={true}
                        isBlocking={false}
                        onDismiss={() => setIsConfigPanelOpen(false)}
                        closeButtonAriaLabel="Close"
                        onRenderFooterContent={() => <DefaultButton onClick={() => setIsConfigPanelOpen(false)}>Close</DefaultButton>}
                        isFooterAtBottom={true}
                        styles={panelRowStyles}
                    >
                        <Checkbox
                            className={styles.chatSettingsSeparator}
                            checked={config.isDark}
                            label="Dark Mode"
                            onChange={(_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
                                handleIsDark(!!checked);
                                setConfig(prevConfig => ({...prevConfig,isDark: !!checked}));
                            }}
                        />
                        <div className={styles.betaFeaturesDetails}>Apply Dark Theme</div>
                        <Checkbox
                            className={styles.chatSettingsSeparator}
                            checked={config.experimentalFeatures}
                            label="Random Account Image"
                            onChange={(_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
                                setConfig(prevConfig => ({
                                    ...prevConfig,
                                    experimentalFeatures: !!checked
                                }));
                            }}
                        />
                        <div className={styles.betaFeaturesDetails}>Generated account image instead of user placeholder</div>

                        <div className={styles.versionLabel}>
                            <div>{import.meta.env.VITE_V_TIMESTAMP}</div>
                        </div>
                    </Panel>
                </div>

                {/* 🏛️ history left panel */}
                <Panel
                    isOpen={isLeftPanelOpen}
                    onDismiss={toggleLeftPanel}
                    isLightDismiss={true}
                    closeButtonAriaLabel="Close"
                    headerText="Conversations"
                    type={PanelType.customNear}
                    customWidth="400px"
                    styles={historyPanelStyles}
                >
                    <div className={styles.convoListBox}>
                        {convos.map(item => (
                            <ListItemButton
                                key={item.key}
                                onClick={() => {
                                    if (config.showDocLibInChatTab == true) {
                                        setConfig(prevConfig => ({
                                            ...prevConfig,
                                            showDocLibInChatTab: false
                                        }));
                                    }
                                    setConversation(item.key);
                                }}
                                onDelete={() => histItemHandleDelete(item.key)}
                                onEdit={newText => histItemHandleEdit(item.key, newText)}
                                text={item.name}
                                className={`${styles.conversationsList} ${activeConvoKey === item.key ? styles.listItemBold : ""}`}
                                disabled={isLoading || isStreaming}
                            />
                        ))}
                    </div>
                </Panel>

                {/* 🧊 spaces left panel */}
                <SpacePanel
                    isSpacePanelOpen={isSpacePanelOpen}
                    toggleSpacePanel={toggleSpacePanel}
                    groupList={groupList?.sort((a, b) => {
                        if (a.oid < b.oid) return 1;
                        if (a.oid > b.oid) return -1;
                        return 0;
                    })}
                    selectedGroup={selectedGroup}
                    setGrpTab={navGrpTab}
                    handleLeftSpacePanelClick={(item: any, aCK?: string, hideRootTabs?: number) => {
                        handleLeftSpacePanelClick(item, aCK, hideRootTabs);
                    }}
                    recentConvosAccrossSpaces={recentConvosAccrosSpaces || []}
                    activeConvoKey={activeConvoKey}
                />

                {/* 🌎 user list modal */}
                <Modal
                    isOpen={isUserListModalOpen}
                    onDismiss={() => {
                        setIsUserListModalOpen(false);
                    }}
                    isBlocking={false}
                    containerClassName={styles.glUserLostModal}
                >
                    <h3 className={styles.modalTitle}>Global Users List</h3>
                    <UserList
                        users={allUsrs}
                        activeComp={activeComp}
                        userMngmntUpdate={userMngmntUpdate}
                        companies={compFlatList}
                        loggedInUser={loggedInUser}
                        src='modal'
                    />{" "}
                </Modal>

                {/* 🏬 companies modal */}
                <RModal
                    isOpen={isCompListModalOpen}
                    onRequestClose={() => setIsCompListModalOpen(false)}
                    shouldCloseOnOverlayClick={true}
                    className={{
                        base: styles.compModalContent,
                        afterOpen: styles.compModalContentAfterOpen,
                        beforeClose: styles.compModalContentBeforeClose
                    }}
                    overlayClassName={styles.compModalOverlay}
                    shouldFocusAfterRender={true}
                    appElement={document.getElementById("kgnfmodcomp")!}
                >
                    <div>
                        <IconButton
                            iconProps={{ iconName: "Cancel" }}
                            onClick={() => setIsCompListModalOpen(false)}
                            ariaLabel="Close"
                            className={styles.compModalCloseButton}
                        />

                        <CompList comps={compFlatList} newActiveComp={handleCompChange} activeComp={activeComp} loggedInUser={loggedInUser} src="modal" />
                    </div>
                </RModal>

                {/* 🆕 new space modal tstz  */}
                <AddSpaceModal
                    isSpaceModalOpen={isSpaceModalOpen}
                    closeSpacesPanel={() => setIsSpaceModalOpen(false)}
                    isNewSpaceInfoBip={isNewSpaceInfoBip}
                    user={user}
                    addSpace={addSpace}
                />

                {/* 📕 pdf modal */}
                <RModal
                    key={`mx_${selectedGroup?.oid}`}
                    isOpen={isPDFModalOpen.isOpen}
                    onRequestClose={onXplrrPDFDismiss}
                    shouldCloseOnOverlayClick={true}
                    onAfterClose={() => {onXplrrPDFModelClosed()}}
                    closeTimeoutMS={100}
                    className={{
                        base: selectedGroup?.assistanttype == assistantCodes.ipa ? styles.modalContentIPA : styles.modalContent,
                        afterOpen: styles.modalContentAfterOpen,
                        beforeClose: styles.modalContentBeforeClose
                    }}
                    overlayClassName={styles.modalOverlay}
                    shouldFocusAfterRender={true}
                    appElement={document.getElementById("rro")!}
                >
                    <XplrrPDF
                        startPage={isPDFModalOpen.startPage}
                        citationFileId={isPDFModalOpen.defaultFile}
                        xplrrCitationChangeCallback={xplrrCitationChangeCallback}
                        fileId={isPDFModalOpen.fileId}
                        refPageNum={isPDFModalOpen.refPageNum}
                        isCitation={isPDFModalOpen.isCitation}
                        rndo={isPDFModalOpen.rndo}
                        searchString={isPDFModalOpen.searchString}
                        activeGroupState={isPDFModalOpen.activeGroupId}
                        fileList={fileList}
                        shouldPlayAudio={shouldPlayAudio}
                        isIframe={isIframe && isIframe > 0 ? true : false}
                        onXplrrPDFDismiss={onXplrrPDFDismiss}
                        onDataHighlight={onDataHighlight}
                        isLib={isLib}
                        loggedInUser={loggedInUser}
                        onInvValueUpdate={listRefreshRequest}
                        invDataOverride={versionInvData}
                    />
                </RModal>

                {/* 📄 diff modal */}
                <RModal
                    isOpen={isPDFDiffModalOpen.isOpen}
                    onRequestClose={onXplrrDiffPDFDismiss}
                    shouldCloseOnOverlayClick={true}
                    onAfterClose={() => {
                        onXplrrPDFModelDiffClosed();
                    }}
                    closeTimeoutMS={100}
                    className={{
                        base: styles.modalContent,
                        afterOpen: styles.modalContentAfterOpen,
                        beforeClose: styles.modalContentBeforeClose
                    }}
                    overlayClassName={styles.modalOverlay}
                    shouldFocusAfterRender={true}
                >
                    <XplrrPDFDiff
                        fileItem1={isPDFDiffModalOpen.fl1}
                        fileItem2={isPDFDiffModalOpen.fl2}
                        selectedGroup={selectedGroup}
                        rndo={isPDFDiffModalOpen.rndo}
                        diffRes={isPDFDiffModalOpen.diff}
                        onDiffPDFDismiss={onXplrrDiffPDFDismiss}
                    />
                </RModal>

                {/* 💌 invite modal */}
                {isShareCalloutVisible && (
                    <div className={styles.inviteCallout}>
                        <InviteUserCallout
                            isOpen={isShareCalloutVisible}
                            onDismiss={() => setIsShareCalloutVisible(!isShareCalloutVisible)}
                            addUserButtonRef={addUserButtonRef}
                            inviteUser={inviteUser}
                            selectedGroup={selectedGroup}
                            activeConvoKey={activeConvoKey}
                        />
                    </div>
                )}

                {/* 📢 feedback callout */}
                {isFeedbackDirectOpen && (
                    <div className={styles.feedbackDirectCalloutOutsideWrap}>
                        <FeedbackDirectCallout
                            isOpen={isFeedbackDirectOpen}
                            onDismiss={() => setIsFeedbackDirectOpen(false)}
                            feedbackButtonRef={feedbackDirectButtonRef}
                            loggedInUser={loggedInUser}
                            selectedGroup={selectedGroup}
                        />
                    </div>
                )}

                {/* 🛟 support modal */}
                <Modal
                    isOpen={isSupportModalOpen}
                    onDismiss={() => setIsSupportModalOpen(false)}
                    isBlocking={false}
                    containerClassName={styles.supportModalContainer}
                >
                    <div className={styles.supportModalHeader}>
                        <div>Send Question to Support</div>
                        <IconButton
                            iconProps={{ iconName: 'Cancel' }}
                            onClick={() => setIsSupportModalOpen(false)}
                            ariaLabel="Close"
                        />
                    </div>
                    <div className={styles.supportModalBody}>
                        <div style={{ marginBottom: '16px' }}>
                            The following question will be sent to our support team and we will respond as soon as possible:
                        </div>
                        <div className={styles.supportQuestionPreview}>
                            <div>{supportQuestion}</div>
                        </div>
                        {loggedInUser?.mail.indexOf("kognify.ai") > 0 && (
                            <TextField
                                styles={textFieldModalSupportStyles}
                                label="Mail"
                                value={userMailForSupport}
                                onChange={(event, newValue) => setUserMailForSupport(newValue || '')}
                                className={styles.spaceTextFields}
                            />
                        )}
                    </div>
                    <div className={styles.supportModalFooter}>
                        <DefaultButton
                            text="Cancel"
                            onClick={() => setIsSupportModalOpen(false)}
                            style={{ marginRight: '8px' }}
                        />
                        <DefaultButton
                            text="Send"
                            primary
                            onClick={() => handleSendToSupport(supportQuestion, userMailForSupport)}
                        />
                    </div>
                </Modal>

                {/* Chart Regeneration Callout */}
                {chartRegenCallout.isOpen && chartRegenCallout.anchorEl && (
                    <Callout
                        target={chartRegenCallout.anchorEl}
                        onDismiss={handleChartRegenDismiss}
                        directionalHint={DirectionalHint.bottomCenter}
                        isBeakVisible={true}
                        styles={{ root: { padding: 0 } }}
                    >
                        <div style={{ padding: 16, minWidth: 280, maxWidth: 350 }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#2f4858', marginBottom: 12 }}>
                                Regenerate Chart
                            </div>
                            <TextField
                                placeholder="Enter instructions for the new chart..."
                                multiline
                                rows={3}
                                value={chartInstruction}
                                onChange={(_, val) => setChartInstruction(val || "")}
                                disabled={isChartLoading}
                                style={{ marginBottom: 12 }}
                            />
                            <PrimaryButton
                                text={isChartLoading ? "Generating..." : "Generate"}
                                onClick={handleChartRegenSubmit}
                                disabled={isChartLoading || !chartInstruction.trim()}
                                style={{ width: '100%' }}
                            />

                        </div>
                    </Callout>
                )}
            </div>
        </ThemeProvider>
    );
};

export default Chat;
